/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import update from 'immutability-helper';
import _, { forEach, lastIndexOf } from 'lodash';
import {
  DtpContentContainer,
  DtpNoContent,
  DtpTabGroup,
  DtpTab,
} from 'dtp-react-components';
import store from '../../../reducers';
import moment from 'moment';
import {
  Button,
} from '../../../components/index';
import {
  doPost,
  trataMensagensErro,
  trataMensagemSucesso,
  validateObject,
  doGet,
  doPut,
  requestTiposDocumentos,
  doMultipartFormPost,
  solicitarEntesControlados,
  doMultipartFormPostExigencias,
  requestMotivos,
  requestMotivosCessacaoRequerimentoAposentadoria,
} from '../../../utils/requests';
import ProtectedItem from '../../../components/ComponentesAutenticacao/ProtectedItem';
import ListaExigencias from '../ListaExigencias';
import ListaAlertas from '../ListaAlertas';
import DadosRequerimentoAposentadoria from './DadosRequerimentoAposentadoria';
import DadosHistoricoRequerimento from '../DadosHistoricoRequerimento';
import DadosHistoricoPrescricao from '../DadosHistoricoPrescricao';
import DadosRelacoesPrevidenciarias from './DadosRelacoesPrevidenciarias';
import DadosResultadoSimulacao from './DadosResultadoSimulacao';
import ModalAlerta from '../ModalAlerta';
import {
  msgsConfirmacao,
  msgsConfirmacaoIndeferimento,
  alertaPesquisarDadosPessoais,
  alertaPesquisarDadosBeneficio,
  msgConfirmacaoRequerimentosPeriodos,
  msgReqAprovadoSemDataIngresso,
  msgCtcNaoEncontrada,
  msgRecalcularTempoRO,
} from '../../../utils/constants';
import {
  getObject,
} from '../../../utils/listsSelect';
import { manterApenasFiltro, habilitarUploadNaConsultaDoRequerimento, stringToData, adicionarQuantidadeAumaData } from '../../../utils/helpers';
import User from '../../../domain/User';
import ModalRejeicaoRequerimento from '../../consultas/Exigencia/ModalRejeicaoRequerimento';
import ModalTempoRO from '../ModalTempoRO';
import * as constantes from '../../../utils/constants';
import ListaConflitosPeriodos from './ListaConflitosPeriodos';

const camposPreenchidosPorServico = {
  cnis: [
    'nome',
    'nit',
    'dataNascimento',
    'sexo',
    'nomeMae',
    'isObtidoPelaRFB',
  ],
  centralService: [
    'tipoAposentadoria',
    'dataInicioBeneficio',
    'dataInicioPagamentoBeneficio',
    'dataCessacaoBeneficio',
    'rendaMensalInicial',
    'dataCreditoPagamento',
    'tempoContribuicaoTotalDias',
    'idUOMantenedora',
  ],
};

const DOC_HOMOLOGACAO_TRIBUNAL = 2;
const DATA_MARCO_COMPENSACAO = '01/01/2020';
const ESTADO_INDEFERIDO_RATIFICADO = 16;
const EXIGENCIA_PERIODOS_ORIGEM = 83;

// Definir como atributos bloqueados para edição na abertura:
// Tipo aposentadoria, data de inicío de benefício,
// data de inicio de pagamento, data de cessação, RMI, UO mantenedora e Data de crédito

class RequerimentoAposentadoria extends Component {

  constructor(props, context) {
    super(props, context);
    this.tabVinculosRef = React.createRef();
    this.clickVinculosTab = this.clickVinculosTab.bind(this);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    tabPaginaAtual: 0,
    requerimento: {
      cpf: null,
      dataCessacaoBeneficio: null,
      dataInicioBeneficio: null,
      dataInicioPagamentoBeneficio: null,
      dataNascimento: null,
      destinatario: null,
      solicitanteOrigem: null,
      documentosProbatorios: [],
      exigencias: [],
      estadoAtual: null,
      estado: null,
      matricula: null,
      nome: null,
      nomeMae: null,
      nit: null,
      elos: [],
      numeroBeneficio: null,
      protocoloCertidao: null,
      rendaMensalInicial: null,
      sexo: null,
      tempoContribuicaoRegimeOrigemDias: null,
      tempoContribuicaoTotalDias: null,
      tipoAposentadoria: null,
      dataDesvinculacao: null,
      dataIngresso: null,
      valorRmiSimulada: null,
      valorRmiReajustada: null,
      valorRmiCompensacaoPrevidenciaria: null,
      valorPercentualParticipacao: null,
      valorProRataInicial: null,
      valorSalarioMinimo: null,
      valorMedioBeneficios: null,
      estados: [],
      resultadoSimulacao: [],
      relacoesPrevidenciariasDestinatario: [],
      dataCreditoPagamento: null,
      dataMigracao: null,
      idUOMantenedora: null,
      qtdDiasEstadoAguardandoAnalise: null,
      arquivos: [],
      alertas: [],
      regraDeCalculo: null,
      destinatarioOrigem: null,
      cpfUsuarioResponsavel: null,
      listaMotivosIndeferimento: [],
      requerimentoPeriodos: [],
      requerimentoPeriodosExcluidos: [],
      tipoSegregacaoSolicitante: null,
      tipoSegregacaoDestinatario: null,
      alteracaoTempoRO: 0,
      ctcEspecifica: 0,
      conclusaoAnalise: null,
      listaConflitosPeriodos: [],
      motivoCessacaoManual: null,
      prescricao: null,
    },
    vinculosSelecionados: [],
    touched: false,
    cpfTouched: false,
    exigenciasInvalidas: {
      dataIngresso: false,
      dataDesvinculacao: false,
      tempoContribuicaoRegimeOrigemDias: false,
    },
    validadeCampos: {
      cpf: false,
      dataInicioBeneficio: false,
      dataNascimento: false,
      destinatario: false,
      solicitanteOrigem: false,
      nit: false,
      rendaMensalInicial: false,
      sexo: false,
      tempoContribuicaoTotalDias: false,
      tipoAposentadoria: false,
      idUOMantenedora: false,
      requerimentoPeriodos: false, 
      dataMotivoCessacao: true,
    },
    isObtidoPelaRFB: false,
    tipoRequerimento: 1,
    sucessoUpload: false,
    acao: 'novo',
    estadoFormulario: 'inicial',
    showNoContent: false,
    noContentPrimaryMessage: 'Requerimento não encontrado para o protocolo informado.',
    noContentSecondaryMessage: 'Informe um protocolo válido.',
    requestPesquisa: null,
    showModalAlerta: false,
    showModalAlertaRequerimentosPeriodos: false,
    showModalAlertaRequerPerConcomitancia: false,
    showModalAlertaCtcNaoEncontrada: false,
    showModalAlertaReqAprovadoSemDataIngresso: false,
    showModalRecalcularTempoRO: false,
    chaveConfirmacao: null,
    isRmiZerada: false,
    rendaMensalInicialRequest: null,
    requerimentoVindoDoRequest: null,
    vinculosConcomitantesConfirmado: false,
    possuiVinculosConcomitantes: false,
    exibirBotaoVoltar: true,
    exibirCampoUoInss: false,
    exibirUploadArquivosNaConsulta: false,
    exibirModalCadeiaDeNit: false,
    exibirModalDataCessacao: false,
    exibirModalMotivoCessacao: false,
    exibirModalSegregacaoMassa: false,
    exibirModalDataEMotivoCessacao: false,
    origemModalSegregacaoMassa: null,
    showRejeicaoRequerimentoModal: false,
    habilitarBotaoCarregarDocumento: false,
    exigenciasOriginais: [],
    isCpfLogadoIgualCpfUsuarioResponsavel: false,
    validadeBotoesIndeferidos: {
      pesquisarDadosPessoais: false,
      pesquisarDadosBeneficio: false,
    },
    destinatarioAlterado: {
      codigoDestinatario: null,
      codigoDestinatarioOrigem: null,
    },
    checkExigirQualificacao: false,
    inIndefericaoAnalise: false,
    motivosIndeferimentoControle: [],
    exibirMultiplosPeriodos: false,
    protocoloCertidaoTouched: false,
    requerimentosPeriodosVindosDoRequest: [],
    habilitarCamposParaAlteracaoNaAnalise: true,
    duplaDestinacao: false,
    concomitanciaDePeriodosNoRequerimento: false,
    listaExigenciasAtendidas: [],
    periodosOriginais: [],
    rejeitar: false,
    clicouBotaoPesquisarCtc: false,
    historyTempoRO: null,
    historyCheckTempoRO: null,
    tipoDocumento: null,
    // listaConflitosPeriodos: [],
    listaMotivosCessacao: [],
    labelMotivoCessacaoManual: null,
  });

  componentDidMount() {
    this.montaFormulario();
  }

  getLotacao = (roles) => {
    let array = '';
    const lotacao = [];
    roles.forEach((role) => {
      const eNovo = role.match(/TD/g);
      const temPA = role.indexOf('|PA|') !== -1;
      if (temPA && eNovo) {
        array = role.split('|');
        for (let i = 0, tam = array.length; i < tam; i += 1) {
          if (array[i] === 'TD') {
            lotacao.push(array[i + 3]);
            break;
          }
        }
      }
    });
    return lotacao;
  }

  clickVinculosTab() {
    this.tabVinculosRef.current.click();
  }

  apagaRegraDeCalculo = () => {
    const requerimento = { ...this.state.requerimento };
    requerimento.regraDeCalculo = null;
    this.setState({ requerimento });
  }

  carregarMotivosCessacao = () => {
    if (this.props.motivosCessacao.length === 0) {
      requestMotivos();
    }
  }

  addMotivoCessacaoManualLabel = (motivo) => {
    if (motivo !== null) {
      const obj = getObject(this.props.motivosCessacao, motivo);
      if (obj !== undefined) {
        this.setState({ labelMotivoCessacaoManual: obj.label});
      }
    }
  }

 isDataMotivoValido = (estadoParam) => {
    const estado = estadoParam || this.state;

    const { acao, requerimento } = estado;

    const listaAcoes = ['realizar-analise', 'novo', 'cumprir-exigencia', 'indeferidos'];

    const temMotivo =
      requerimento.motivoCessacaoManual !== null &&
      requerimento.motivoCessacaoManual !== undefined &&
      requerimento.motivoCessacaoManual !== '';

    const temData =
      requerimento.dataCessacaoBeneficio !== null &&
      requerimento.dataCessacaoBeneficio !== undefined &&
      requerimento.dataCessacaoBeneficio !== '';

    return (
      !listaAcoes.includes(acao) || // fora das ações → ignora
      (temMotivo && temData) ||     // ambos preenchidos
      (!temMotivo && !temData)      // ambos vazios
    );
  };

  validarCamposMotivo = () => {
    const { requerimento } = this.state;

    const temMotivo = !!requerimento.motivoCessacaoManual;
    const temData = !!requerimento.dataCessacaoBeneficio;

    return temMotivo === temData;
  };

  /** Se URL possuir protocolo, requerimento deve ser buscado.
   *  Se URL possuir acao, atualizar state com acao indicada,
   *  senao assume-se que o usuario apenas consulta o requerimento quando protocolo for informado
   *  Protocolo deve ser numerico;
   *  Acao deve ser cumprir-exigencia, realizar-analise ou emitir-parecer-medico.
   * */
  montaFormulario = () => {
    this.carregarMotivosCessacao();
    if (this.props.match.params.protocolo) {
      const acao = this.props.match.params.acao ? this.props.match.params.acao : 'consulta';
      this.setState({ acao }, this.buscaRequerimento);
    } else {
      manterApenasFiltro('');
      if (this.props.auth.checkPermission(['requerer-compensacao-rgps', 'gerenciar-negocio-dcomp'])) {
        this.setState({
          validadeCampos: {
            ...this.state.validadeCampos,
            numeroBeneficio: false,
          },
        }, this.buscarTiposDocumentosUpload);
      } else if (this.props.auth.checkPermission(['requerer-compensacao-rpps'])) {
        this.setState(this.buscaParticipantePeloCnpjLogado());
        this.setState({
          validadeCampos: {
            ...this.state.validadeCampos,
            matricula: false,
          },
        }, this.buscarTiposDocumentosUpload);
      }
      this.controlarExibicaoMultiplosPeriodos();
    }
  }

  buscaRequerimento = (metodoSucesso = this.handleSuccessBuscaRequerimento) => {
    if (this.state.acao !== 'novo') {
      const url = `requerimentos-compensacao-aposentadoria/${this.props.match.params.protocolo}`;
      doGet(url, metodoSucesso, this.handleErrorBuscaRequerimento);
    }
  }

  buscaRequerimentoAposRejeitar(response) {
    const url = `requerimentos-compensacao-aposentadoria/${response.data.protocolo}`;
    doGet(url, this.handleSuccessBuscaRequerimentoAposSalvarERejeitar, this.handleErrorBuscaRequerimento);
  }

  buscaRequerimentoAposAlteracaoPeriodo() {
    const url = `requerimentos-compensacao-aposentadoria/${this.state.requerimento.protocolo}`;
    doGet(url, this.handleSuccessBuscaRequerimento, this.handleErrorBuscaRequerimento);
  }

  buscaMotivosCessacaoRequerimentoAposentadoria = (tipo, tipoMotivo, tipoBeneficio) => {
    requestMotivosCessacaoRequerimentoAposentadoria(
      this.handleErrorBusca,
      tipo,
      tipoMotivo,
      tipoBeneficio,
    );
  }

  handleSuccessBuscaParticipantePeloCnpjLogado = (response) => {
    const { requerimento } = { ...this.state };
    //requerimento.idUOMantenedora = response.data.idUOInssConvenio;
    const idUOMantenedora = response.data.idUOInssConvenio;
    this.setState({
      // requerimento: { ...this.state.requerimento, requerimento },
      requerimento: {
        ...requerimento,
        idUOMantenedora,
      },
    }, () => {
      if (response.data.inOrgaoUniao) {
        solicitarEntesControlados(response.data.codigo, this.handleEntesControlados);
      }
    });
  }

  handleEntesControlados = (e) => {
    store.dispatch({ type: 'SALVA_ENTES_CONTROLADOS', payload: e.data });
  }

  handleErrorBuscaParticipantePeloCnpjLogado = () => {
    const mensagemPrimaria = 'Não foi possível consultar o ente participante.';
    const mensagemSecundaria = 'Contate o administrador do sistema.';
    this.setState({
      showNoContent: true,
      noContentPrimaryMessage: mensagemPrimaria,
      noContentSecondaryMessage: mensagemSecundaria,
    });
  };

  buscaParticipantePeloCnpjLogado =
    (metodoSucesso = this.handleSuccessBuscaParticipantePeloCnpjLogado) => {
      const lotacaoUsuario = this.getLotacao(this.props.auth.userData.roles);

      if (lotacaoUsuario.length > 0) {
        const primParte = [];
        const segParte = [];
        if (lotacaoUsuario[0].indexOf('#') !== -1) {
          const arrayLotacao = lotacaoUsuario[0].split('#');
          primParte.push(arrayLotacao[0]);
          segParte.push(arrayLotacao[1]);
        }
        const url = `participantes-compensacao/${segParte}`;
        doGet(
          url,
          metodoSucesso,
          this.handleErrorBuscaParticipantePeloCnpjLogado,
        );
      }
    }

  handleSuccessBuscaQuantidadeAprovadosSemDataIngresso = (response) => {
    if (response.data > 0) {
      this.setState({
        chaveConfirmacao: '',
        alertas: [],
        showModalAlertaReqAprovadoSemDataIngresso: !this.state.showModalAlertaReqAprovadoSemDataIngresso,
      });
    }
  }

  handleSuccessBuscaListaConflitosPeriodos = (response) => {
    if (response.data) {
      let lista = [];
      if (response.data && response.data.length > 0) {
        lista = response.data;
      }
      this.setState(prevState => ({
        requerimento: {
          ...prevState.requerimento,
          listaConflitosPeriodos: lista
        }
      }));
    }
  }

  buscaQuantidadeAprovadosSemDataIngresso = (cpf) => {
    const url = `requerimentos-compensacao-aposentadoria/quantidade-aprovados-sem-data/cpf/${cpf}`;
    doGet(url, this.handleSuccessBuscaQuantidadeAprovadosSemDataIngresso, this.handleErrorBuscaRequerimento);
  }

  buscaListaConflitosPeriodos = () => {
    const url = `requerimentos-compensacao-aposentadoria/conflito-periodos/lista`;
    const protocolo = this.props.match.params.protocolo;
    doGet(
      `${url}/${protocolo}`,
      this.handleSuccessBuscaListaConflitosPeriodos,
      this.handleErrorBuscaRequerimento,
    );
  }

  handleSuccessBuscaRequerimentoAposSalvarERejeitar = (response) => {
    this.setState({
      requerimento: { ...this.state.requerimento, ...response.data },
    });
  }

  isDataCessacaoManualPreenchida = () => (
    (
      this.state.requerimento.dataCessacaoBeneficio !== null &&
      this.state.requerimento.dataCessacaoBeneficio !== '' &&
      this.state.requerimento.dataCessacaoBeneficio !== undefined
    )
  );

  isMotivoCessacaoManualPreenchido = () => (
    (
      this.state.requerimento.motivoCessacaoManual !== null &&
      this.state.requerimento.motivoCessacaoManual !== '' &&
      this.state.requerimento.motivoCessacaoManual !== undefined
    )
  );

  verificarValidadeMotivoCessacaoManual = (dataCessacaoBeneficio, motivoCessacaoManual) => {
    const existeDataPreenchida = (dataCessacaoBeneficio !== null && dataCessacaoBeneficio !== '' && dataCessacaoBeneficio !== undefined);
    const existeMotivoCessacaoManual = (motivoCessacaoManual !== null && motivoCessacaoManual !== '' && motivoCessacaoManual !== undefined);
    if ( existeDataPreenchida && existeMotivoCessacaoManual) {
      return true;
    }
    if ( !existeDataPreenchida && !existeMotivoCessacaoManual) {
      return true;
    }
    return false;
  };

  handleSuccessBuscaRequerimentoAtualizacao = (response) => {
    const validadeCampos = this.montaValidadeCampos(response.data);
    if (response.data) {
      if (response.data.estado === 2) {
        const requerimentoVindoDoRequest = response.data;
        this.setState({ requerimentoVindoDoRequest });
      }
    }
    this.setState({
      requerimento: response.data,
      estadoInicialRequerimento: response.data.estado,
      touched: true,
      validadeCampos,
    }, this.validaVoltaPagina);
  }

  validaVoltaPagina = () => {
    if (!this.state.requerimento.exigencias
      || this.state.requerimento.exigencias
        .filter(exigencia => exigencia.tipoDocumento).length
      === this.state.requerimento.exigencias.length) {
      this.props.history.goBack();
    }
  }

  /**
   * Verifica se ha campos a serem alterados na lista de exigencia
   * se requerimento estiver no estado Em-Exigencia (2)
   * Quando estado diferente de Em-exigencia:
   *  todos os campos que nao possuirem exigencias associadas serao considerados validos
   */
  montaValidadeCampos = (requerimento) => {
    const { validadeCampos } = { ...this.state };
    Object.keys(requerimento).forEach((key) => {
      if (!['tempoContribuicaoRegimeOrigemDias', 'dataIngresso', 'dataDesvinculacao'].includes(key)) {
        validadeCampos[key] = true;
      }
    });
    if (this.state.acao === 'cumprir-exigencia' && requerimento.estado === 2) {
      if (requerimento.exigencias) {
        const exigenciaComAtributo = requerimento.exigencias.filter(item => item.atributo);
        exigenciaComAtributo.forEach((exigencia) => {
          if (!['tempoContribuicaoRegimeOrigemDias', 'dataIngresso', 'dataDesvinculacao'].includes(exigencia.atributo)) {
            validadeCampos[exigencia.atributo] = false;
          }
        });
      }
      if ((this.verificarValidadeMotivoCessacaoManual(requerimento.dataCessacaoBeneficio, requerimento.motivoCessacaoManual))) {
        validadeCampos.dataMotivoCessacao = true;
      }
        else {
        validadeCampos.dataMotivoCessacao = false;
      }
    }

    if (this.state.acao === 'qualificar'
      && requerimento.estado === 2 && requerimento.exigencias) {
      const exigenciaQualificacao = requerimento.exigencias.find(item => item.tipo === 72);
      if (exigenciaQualificacao) {
        validadeCampos.cpf = false;
      }
    }
    return validadeCampos;
  }

  handleSearchNBButtonExigencia = () => {
    this.setState(this.handleNBSearchExigencia);
  }

  trataSucessoResponseNBExigencia = (response) => {
    const { validadeCampos } = { ...this.state };
    const { requerimento } = { ...this.state };
    const idUoMantenedoraRequest = response.data.idUOMantenedora;
    const idUOMantenedora = idUoMantenedoraRequest;
    const novoRequerimento = {
  ...requerimento,
  ...response.data,
};

const dataMotivoValido = this.isDataMotivoValido({
  ...this.state,
  requerimento: novoRequerimento,
});

this.setState({
  requerimento: novoRequerimento,
  requestPesquisa: null,
  validadeCampos: {
    ...validadeCampos,
    dataMotivoCessacao: dataMotivoValido,
  },
});
    this.setState({
      requerimento: {
        ...requerimento,
        idUOMantenedora,
      },
      requestPesquisa: null,
      validadeCampos,
    });
  }

  handleNBSearchExigencia = () => {
    const { requerimento } = { ...this.state };
    if (requerimento.numeroBeneficio) {
      const { numeroBeneficio } = { ...this.state.requerimento };
      this.setState(
        { requestPesquisa: 'centralService' },
        doGet(
          `beneficio-rgps/${numeroBeneficio}`,
          this.trataSucessoResponseNBExigencia,
          this.trataErrosResponse,
        ),
      );
    }
  }

  verificaIndefericaoAnalise = () => {
    const { estados } = { ...this.state.requerimento };
    let { motivosIndeferimentoControle } = { ...this.state };
    if (estados && estados.length > 0) {
      if (estados[0].motivos && estados[0].motivos.length > 0) {
        motivosIndeferimentoControle = estados[0].motivos;
        this.setState({ motivosIndeferimentoControle, inIndefericaoAnalise: true });
        const changeObj = { value: 9 };
        this.alteraEstadoRequerimento(changeObj);
        requestMotivos();
      }
    }
  }

  handleSuccessBuscaRequerimento = (response) => {
    const validadeCampos = this.montaValidadeCampos(response.data);
    let { exibirCampoUoInss } = { ...this.state };
    let { historyTempoRO } = { ...this.state };
    if (response.data) {
      const requerimentoVindoDoRequest = response.data;
      const solicitanteRGPS =
        requerimentoVindoDoRequest.solicitante && requerimentoVindoDoRequest.solicitante.codigo === '01000';
      const destinatarioRGPS =
        requerimentoVindoDoRequest.destinatario && requerimentoVindoDoRequest.destinatario.codigo === '01000';
      historyTempoRO = response.data.tempoContribuicaoRegimeOrigemDias;

      if (response.data.estado === 2) { // em exigência mas pode nao ser consulta
        if (requerimentoVindoDoRequest.solicitanteOrigem === undefined) {
          validadeCampos.solicitanteOrigem = true;
        }
        let { periodosOriginais } = { ...this.state };
        if (requerimentoVindoDoRequest.requerimentoPeriodos !== undefined) {
          requerimentoVindoDoRequest.requerimentoPeriodos.forEach((periodo) => {
            if (periodosOriginais.length !== 0) {
              const index = periodosOriginais.findIndex(p => (p.idPeriodo !== periodo.idPeriodo));
              if (index !== -1) {
                periodosOriginais.push(periodo);
              }
            } else {
              periodosOriginais.push(periodo);
            }
          });
          this.setState({ periodosOriginais });
        }
        this.setState({ requerimentoVindoDoRequest });
        // IB 282195
        if (this.state.acao === 'consulta') {
          let { exigenciasOriginais } = { ...this.state };
          let { exibirUploadArquivosNaConsulta } = { ...this.state };

          requerimentoVindoDoRequest.exigencias.forEach((exigencia) => {
            exigenciasOriginais.push(exigencia);
          });
          const usuarioLogado = User.logged();
          const isCpfLogadoIgualCpfUsuarioResponsavel = (usuarioLogado.data.prevCpf === requerimentoVindoDoRequest.cpfUsuarioResponsavel);
          // isCpfLogadoIgualCpfUsuarioResponsavel é o cpf de quem pegou o requerimento para analisar no GET
          if (!solicitanteRGPS) {
            exibirUploadArquivosNaConsulta = true;
          } else if (isCpfLogadoIgualCpfUsuarioResponsavel && solicitanteRGPS) {
            exibirUploadArquivosNaConsulta = true;
          }
          this.setState({ exigenciasOriginais, exibirUploadArquivosNaConsulta });
        }
      }
      // pesquisar a quantidade de requerimentos aprovados sem data de ingresso
      if (response.data.estado === 6 && this.state.tipoRequerimento === 1) {
        this.buscaQuantidadeAprovadosSemDataIngresso(response.data.cpf);
      }
      // buscar requerimentos com conflitos de periodos
      // if (!this.props.auth.checkPermission(['fornecer-parecer-medico-rpps'])) {
      //   this.buscaListaConflitosPeriodos();
      // }

      if (this.state.acao === 'indeferidos' || this.state.acao === 'complementar-aposentadoria') {
        validadeCampos.solicitanteOrigem = true;
      }

      // if (this.state.acao === 'complementar-aposentadoria') {
      //   validadeCampos.solicitanteOrigem = true;
      //   validadeCampos.dataHomologacaoTribunalContas = false;
      // }

      // IB 282195
      if (this.state.acao === 'consulta' && response.data.estado !== 2) {// !this.isConsultaExigencia()
        const paramUploadArquivosNaConsulta =
          habilitarUploadNaConsultaDoRequerimento(requerimentoVindoDoRequest, this.state.acao, null);
        this.setState({ exibirUploadArquivosNaConsulta: paramUploadArquivosNaConsulta });
      }

      if (solicitanteRGPS || destinatarioRGPS) {
        exibirCampoUoInss = true;
        this.setState({ exibirCampoUoInss });
      }
      this.addMotivoCessacaoManualLabel(response.data.motivoCessacaoManual);
    }

    this.setState({
      requerimento: { ...this.state.requerimento, ...response.data },
      estadoInicialRequerimento: response.data.estado,
      touched: true,
      validadeCampos,
      historyTempoRO,
    }, () => {
      if (this.state.acao === 'realizar-analise') {
        this.state.requerimento.relacoesPrevidenciariasDestinatario
          .map(relacao => relacao.regimePrevidenciario)
          .flat()
          .forEach(regime => this.marcarRegime(regime));
      }
      this.buscarTiposDocumentos();
    });

    if (this.state.requerimento.estado === 6) {
      this.verificaIndefericaoAnalise();
    }

    // IB422810 - MÉTODOS PARA OS SUBPERIODOS
    this.controlarExibicaoMultiplosPeriodos();
    // this.atualizarDataIngressoDesvinculacaoETempo(this.state.requerimento.requerimentoPeriodos);
    this.verificarHabilitacaoDataIngressoDesvinculacaoETempo();
    this.marcarExigenciaInvalidaDataIngressoDesvinculacaoETempoRO();
    // IB422810 - MÉTODOS PARA OS SUBPERIODOS
  }

  buscarTiposDocumentosUpload = () => {
    requestTiposDocumentos(this.handleErrorBusca);
  }

  isConsultaExigencia = () => (this.state.acao === 'consulta' && this.state.requerimento.estado === 2);

  buscarTiposDocumentos = () => {
    requestTiposDocumentos(this.handleErrorBusca);
  }

  montaListaMotivosDisponiveis = () => {
    let listaMotivos = [];
    this.props.motivosCessacaoRequerimentoAposentadoria.forEach((motivo) => {
      if (motivo.value !== 24) {
        listaMotivos.push({
          value: motivo.value,
          label: motivo.label,
        });
      }
    });
    this.setState({
      listaMotivosCessacao: listaMotivos,
    });
  }

  /**
   * Trata erros na busca pelo requerimento, mostrando tela default para
   * falta de conteúdo.
   */
  handleErrorBuscaRequerimento = (error) => {
    let mensagemPrimaria = 'Não foi possível consultar o requerimento.';
    let mensagemSecundaria = 'Contate o administrador do sistema.';
    if (error) {
      if (error.status) {
        if (error.status === 404) {
          mensagemPrimaria = 'Requerimento não encontrado para o protocolo informado.';
          mensagemSecundaria = 'Informe um protocolo válido.';
        }
      }
    }
    this.setState({
      showNoContent: true,
      noContentPrimaryMessage: mensagemPrimaria,
      noContentSecondaryMessage: mensagemSecundaria,
    });
  };

  handleErrorBusca = () => {
    const mensagemPrimaria = 'Não foi possível consultar o requerimento.';
    const mensagemSecundaria = 'Contate o administrador do sistema.';
    this.setState({
      mostraPaginaSemConteudo: true,
      mensagemPrincipalSemConteudo: mensagemPrimaria,
      mensagemSecundariaSemConteudo: mensagemSecundaria,
    });
  }

  alteraEstadoRequerimento = (changeObj) => {
    if (changeObj.value !== 9 && (this.state.motivosIndeferimentoControle &&
      this.state.motivosIndeferimentoControle.length > 0)) {
      this.setState({ inIndefericaoAnalise: false });
    }
    this.setState({
      requerimento: {
        ...this.state.requerimento,
        exigencias: [],
        motivo: null,
        justificativaIndeferimento: null,
        conclusaoAnalise: null,
      },
    }, () => this.handleChange(changeObj, 'estado'));
  }

  verificaCumprimentoExigencia = () => {
    let exigenciaCumprida = false;
    let houveAlteracao = false;
    if (this.state.requerimento.exigencias) {
      this.state.requerimento.exigencias.forEach((item) => {
        if (item.atributo) {
          if (item.atributo in this.state.validadeCampos && this.state.validadeCampos[item.atributo]) {
            exigenciaCumprida = true;
          }
        } else {
          // IB557704 uploads na tela de exigencia
          const { arquivos } = { ...this.state.requerimento };
          if (arquivos) {
            const index = arquivos.findIndex(i => (i.tipoDocumento === item.tipoDocumento));
            if (index !== -1) {
              exigenciaCumprida = true;
            }
          }
        }
      });
    }
    if (exigenciaCumprida) {
      this.state.requerimento.exigencias.forEach((exigencia) => {
        const paramAtributo = exigencia.atributo;
        if (paramAtributo && exigencia.atendida === 0) {
          if (paramAtributo in this.state.validadeCampos) {
            this.state.validadeCampos[paramAtributo] = true;
          }
        }
      });
      const valido = validateObject(this.state.validadeCampos);
      this.state.requerimento.exigencias.forEach((exigencia) => {
        const paramAtributo = exigencia.atributo;
        if (paramAtributo && exigencia.atendida === 0) {
          if (paramAtributo in this.state.validadeCampos) {
            this.state.validadeCampos[paramAtributo] = false;
          }
        }
      });
      if (!valido) {
        houveAlteracao = valido;
      } else {
        houveAlteracao = exigenciaCumprida;
      }
    } else {
      let lista = this.verificaAlteracaoCamposEstadoExigencia();
      if (lista && lista.length === 0) {
        // verificar campos alterados que nao sao exigencia
        lista = this.verificaAlteracaoCamposQueNaoSaoExigencia();
      }
      houveAlteracao = (lista && lista.length > 0);
      const { requestPesquisa } = { ...this.state };
      const alterouPeloBotaoPesquisar = requestPesquisa;
      if (alterouPeloBotaoPesquisar) {
        return true;
      }
      if (houveAlteracao) {
        this.state.requerimento.exigencias.forEach((exigencia) => {
          const paramAtributo = exigencia.atributo;
          if (paramAtributo && exigencia.atendida === 0) {
            if (paramAtributo in this.state.validadeCampos) {
              this.state.validadeCampos[paramAtributo] = true;
            }
          }
        });

        houveAlteracao = validateObject(this.state.validadeCampos);

        this.state.requerimento.exigencias.forEach((exigencia) => {
          const paramAtributo = exigencia.atributo;
          if (paramAtributo && exigencia.atendida === 0) {
            if (paramAtributo in this.state.validadeCampos) {
              this.state.validadeCampos[paramAtributo] = false;
            }
          }
        });
      }
    }
    if (!this.isDataMotivoValido()) {
    return false;
    }
    console.log({
      exigenciaCumprida,
      houveAlteracao,
      validadeCampos: this.state.validadeCampos,
      dataMotivoCessacao: this.state.validadeCampos.dataMotivoCessacao,
      motivo: this.state.requerimento.motivoCessacaoManual,
      data: this.state.requerimento.dataCessacaoBeneficio
    });
    const valido = validateObject(this.state.validadeCampos);
    console.log('validateObject=', valido, this.state.validadeCampos);
    return houveAlteracao;
  }

  /*
   * Verifica a existencia de um determinado tipo de documento carregado em requerimentos
   * neste caso estamos especifico estamos verificando o tipoDocumento = 2  (Homologação Tribunal)
   * se econtrar retorna verdadeiro.
   * @param {*} tipoEmDocumentosProbatorios
   * @returns
   */

  existeTipoDocumentoCarregadoNoRequerimento = (tipoEmDocumentosProbatorios) => {
    const existeTipoDocumento = this.state.requerimento.documentosProbatorios.some(documento => documento.tipoDocumento === tipoEmDocumentosProbatorios);
    return existeTipoDocumento;
  };

  // isDataHomologacaoTribunalContasValid = (tipoEmDocumentosProbatorios, dateAberturaRequerimentoParam) => {
  // const isValid = ((props.estadoFormulario.dataHomologacaoTribunalContas === null || props.estadoFormulario.dataHomologacaoTribunalContas === undefined) &&
  // (props.estadoFormulario.requerimento.dataAberturaRequerimento !== null || props.estadoFormulario.requerimento.dataAberturaRequerimento !== undefined));
  // if (isValid) {
  //   if ((!existeTipoDocumentoCarregadoNoRequerimento(tipoEmDocumentosProbatorios) &&
  //   dateAberturaRequerimentoParam <= dateAberturaRequerimentoObject) ||
  //   (dateAberturaRequerimentoParam > dateAberturaRequerimentoObject)) {
  //     return isValid;
  //   }
  // }
  // return !isValid;
  // };

  verificaPreenchimentoDataHomologacaoTribunalContas = () => {
    const { requerimento } = { ...this.state };
    return requerimento.dataHomologacaoTribunalContas !== null &&
      requerimento.dataHomologacaoTribunalContas !== '' &&
      requerimento.dataHomologacaoTribunalContas !== undefined;
  }

  verificarCondicaoValidaParaComplementar = () => {
    // testar se existe o doc de homologacao do tribunal.
    let existeHomologacaoTribunalAnexada = false;
    let dataHomologacaoPreenchida = false;
    const dataAberturaRequerimento = moment(this.state.requerimento.dataAberturaRequerimento, 'DD/MM/YYYY').toDate();
    const marcoCompensacao = moment(DATA_MARCO_COMPENSACAO, 'DD/MM/YYYY').toDate(); // '01/01/2020'
    let condicaoValidaParaComplementar = false;
    if ((dataAberturaRequerimento <= marcoCompensacao)) {// se a data de abertura do req for menor doque 01/01/2020
      existeHomologacaoTribunalAnexada = this.existeTipoDocumentoCarregadoNoRequerimento(DOC_HOMOLOGACAO_TRIBUNAL);
      dataHomologacaoPreenchida = this.verificaPreenchimentoDataHomologacaoTribunalContas();
      condicaoValidaParaComplementar = (dataHomologacaoPreenchida || existeHomologacaoTribunalAnexada);
    } else {
      condicaoValidaParaComplementar = this.verificaPreenchimentoDataHomologacaoTribunalContas();
    }
    return condicaoValidaParaComplementar;
  }

  /**
   * Para o Formulario estar pronto para envio, deve:
   *  - Ser criacao (acao=novo) e ter todos seus campos validos;
   *  - Ser criacao:
   *     - ter sido enviado com falha em regra de negocio e;
   *     - pelo menos um campo alterado para valido.
   *  - Ser cumprimento de exigencia (acao=cumprir-exigencia) e ter pelo menos uma alteracao;
   *  - Ser Analise (acao=realizar-analise) e ter a analise realizada;
   *  - Ser Analise do Medico Perito (acao=emitir-parecer-medico) e ter a parecer realizado;
   */
  formularioProntoParaEnvio = () => {
    const { acao } = { ...this.state };
    const { estadoFormulario } = { ...this.state };
    const { requerimento } = { ...this.state };

    switch (acao) {
      case 'novo': {
        if (estadoFormulario === 'inicial') {
          this.state.validadeCampos.idUOMantenedora = true;
          return validateObject(this.state.validadeCampos);
        }
        if (estadoFormulario === 'criado') {
          return true;
        }
        if (estadoFormulario === 'alterado') {
          return validateObject(this.state.validadeCampos);
;
        }
      }
      case 'cumprir-exigencia':
        return this.verificaCumprimentoExigencia();
      case 'realizar-analise':
        return this.verificaSeAnaliseCompleta();
      case 'emitir-parecer-medico':
        return typeof this.state.requerimento.enquadraArtigo151Lei8213 === 'boolean' &&
          typeof this.state.requerimento.invalidezAcidentaria === 'boolean';
      case 'qualificar':
        return this.verificaQualificacao();
      case 'consulta':
        return (habilitarUploadNaConsultaDoRequerimento(requerimento, acao, null) &&
          this.state.habilitarBotaoCarregarDocumento);
      case 'indeferidos': {
        if (this.props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps'])) {
          return this.verificaIndeferidos('rgps');
        }
        if (this.props.auth.checkPermission(['analisar-compensacao-rpps', 'requerer-compensacao-rpps'])) {
          return this.verificaIndeferidos('rpps');
        }
      }
      case 'salvarERejeitar':
        return validateObject(this.state.validadeCampos);
      case 'complementar-aposentadoria':
        const condicaoValidaParaComplementar = this.verificarCondicaoValidaParaComplementar();
        return validateObject(this.state.validadeCampos) && condicaoValidaParaComplementar;
      default: return false;
    }
  }

  verificaIndeferidos = (regime) => {
    let retorno = true;
    if (regime === 'rgps') {
      const { validadeCampos } = { ...this.state };
      const { isRmiZerada } = { ...this.state };
      const { isObtidoPelaRFB } = { ...this.state };
      const { validadeBotoesIndeferidos } = { ...this.state };
      const { requerimentoPeriodos } = { ...this.state.requerimento };
      const camposMotivoValidos = this.validarCamposMotivo();

      let camposValidos = false;
      if(validadeCampos.destinatario && camposMotivoValidos){
        camposValidos = true;
      }

      let camposValidosRetornoRFB = true;
      if (isObtidoPelaRFB) {
        camposValidosRetornoRFB = validadeCampos.nit && validadeCampos.sexo;
      }

      let camposValidosRMIZerada = true;
      if (isRmiZerada) {
        camposValidosRMIZerada = isRmiZerada && validadeCampos.rendaMensalInicial;
      }

      if (validadeBotoesIndeferidos.pesquisarDadosPessoais === true) {
        retorno = camposValidos && camposValidosRetornoRFB &&
          validadeBotoesIndeferidos.pesquisarDadosBeneficio &&
          camposValidosRMIZerada && (requerimentoPeriodos && requerimentoPeriodos.length > 0);
      } else {
        retorno = camposValidos && camposValidosRetornoRFB &&
          validadeBotoesIndeferidos.pesquisarDadosBeneficio &&
          this.state.checkExigirQualificacao && this.state.cpfTouched &&
          camposValidosRMIZerada && (requerimentoPeriodos && requerimentoPeriodos.length > 0);
      }
    } else {
      const { validadeCampos } = { ...this.state };
      const { validadeBotoesIndeferidos } = { ...this.state };
      const { requerimentoPeriodos } = { ...this.state.requerimento };
      let camposValidos = false;
      const camposMotivoValidos = this.validarCamposMotivo();

      if ((validadeCampos.matricula)
        && (validadeCampos.tipoAposentadoria)
        && (validadeCampos.dataInicioBeneficio)
        && (validadeCampos.tempoContribuicaoTotalDias)
        && (validadeCampos.rendaMensalInicial)
        && (camposMotivoValidos)) {
          camposValidos = true;
        }

      let camposValidosRetornoRFB = true;
      if (this.state.isObtidoPelaRFB) {
        camposValidosRetornoRFB = validadeCampos.nit && validadeCampos.sexo;
      }

      if (validadeBotoesIndeferidos.pesquisarDadosPessoais === true) {
        retorno = camposValidos && camposValidosRetornoRFB
          && (requerimentoPeriodos && requerimentoPeriodos.length > 0);
      } else {
        retorno = camposValidos && camposValidosRetornoRFB
          && this.state.checkExigirQualificacao && this.state.cpfTouched
          && (requerimentoPeriodos && requerimentoPeriodos.length > 0);
      }
    }
    return retorno;
  }

  verificaQualificacao = () => (
    this.state.validadeCampos.cpf
    && this.state.validadeCampos.nit
    && this.state.validadeCampos.dataNascimento
    && this.state.validadeCampos.sexo
  )
  //nome !== undefined && 
  // IB444230
  validarCamposNulo = (nome) => {
    let retorno = false;
    if (nome !== null) {
      retorno = true;
    }
    return retorno;
  }

  validarCamposUndefined = (nome) => {
    let retorno = false;
    if (nome !== undefined) {
      retorno = true;
    }
    return retorno;
  }

  validarCamposColecaoVazio = (nome) => {
    let retorno = false;
    if (nome && (nome !== undefined && nome !== null) && nome.length > 0) {
      retorno = true;
    }
    return retorno;
  }

  verificarMudancaNosValoresDaColecao = (colecaoOriginal, colecaoAlterada, nomeColecao) => {
    let colecaoOriginalOrdenada = [];
    let colecaoAlteradaOrdenada = [];

    if (colecaoOriginal && colecaoOriginal.length > 0) {
      colecaoOriginalOrdenada = this.ordenarListaPeriodos(colecaoOriginal);
    }

    if (colecaoAlterada && colecaoAlterada.length > 0) {
      colecaoAlteradaOrdenada = this.ordenarListaPeriodos(colecaoAlterada);
    }

    if (nomeColecao === 'requerimentoPeriodos') {
      colecaoOriginalOrdenada.forEach((item) => {
        const indexPeriodo = colecaoAlteradaOrdenada.findIndex(i => (i.idPeriodo === item.idPeriodo));
        const isDataFimAlterada = (colecaoOriginalOrdenada[indexPeriodo].dataFim !== colecaoAlteradaOrdenada[indexPeriodo].dataFim);
        const isDataInicioAlterada = (colecaoOriginalOrdenada[indexPeriodo].dataInicio !== colecaoAlteradaOrdenada[indexPeriodo].dataInicio);
        const isQtdDiasDescontoAlterada = (colecaoOriginalOrdenada[indexPeriodo].qtdDiasDesconto !== colecaoAlteradaOrdenada[indexPeriodo].qtdDiasDesconto);
        if ((isDataFimAlterada || isDataInicioAlterada || isQtdDiasDescontoAlterada)) {
          return true;
        } else {
          return false;
        }
      });
    } else {
      for (let i = 0; i < colecaoAlteradaOrdenada.length; i++) {
        if (colecaoOriginalOrdenada[i] !== colecaoAlteradaOrdenada[i]) {
          // mudou o valor de algum campo dentro da coleção
          return true;
        } else {
          return false;
        }
      }
    }
  }

  verificarMudancaNosValoresDaColecaoPeriodos = (colecaoOriginal, colecaoAlterada, deveValidarTempoDescontado) => {
    let colecaoOriginalOrdenada = [];
    let colecaoAlteradaOrdenada = [];
    let retorno = false;

    if (colecaoOriginal && colecaoOriginal.length > 0) {
      colecaoOriginalOrdenada = this.ordenarListaPeriodos(colecaoOriginal);
    }

    if (colecaoAlterada && colecaoAlterada.length > 0) {
      colecaoAlteradaOrdenada = this.ordenarListaPeriodos(colecaoAlterada);
    }
    colecaoOriginalOrdenada.forEach((item, i) => {
      if (retorno) {
        return retorno;
      }
      const indexPeriodo = i;
      const isDataFimAlterada = (colecaoOriginalOrdenada[indexPeriodo].dataFim !== colecaoAlteradaOrdenada[indexPeriodo].dataFim);
      const isDataInicioAlterada = (colecaoOriginalOrdenada[indexPeriodo].dataInicio !== colecaoAlteradaOrdenada[indexPeriodo].dataInicio);
      const isQtdDiasDescontoAlterada = deveValidarTempoDescontado && (colecaoOriginalOrdenada[indexPeriodo].qtdDiasDesconto !== colecaoAlteradaOrdenada[indexPeriodo].qtdDiasDesconto);
      if ((isDataFimAlterada || isDataInicioAlterada || isQtdDiasDescontoAlterada)) {
        retorno = true;
      } else {
        retorno = false;
      }
    });
    return retorno;
  }

  verificarMudancaNaColecaoDePeriodos = (colecaoOriginal, colecaoAlterada, deveValidarTempoDescontado) => {
    let retorno = false;
    if (colecaoOriginal && colecaoAlterada) {
      if (colecaoOriginal.length !== colecaoAlterada.length) {
        retorno = true;
        // houve alteracao - cumpre exigencia
      } else if (colecaoOriginal.length === colecaoAlterada.length) {
        // verificar se houve mudanca nos valores
        retorno = this.verificarMudancaNosValoresDaColecaoPeriodos(colecaoOriginal, colecaoAlterada, deveValidarTempoDescontado);
      }
    }
    return retorno;
  }

  // IB444230
  verificarMudancaNoValorDoCampo = (campo1, campo2) => {
    let retorno = false;
    if (campo1 !== campo2) {
      retorno = true;
    }
    if (campo1 === undefined && campo2 === null) {
      retorno = false;
    }
    return retorno;
  }

  // IB444230
  // Verifica se existe uma exigência já atendida associada ao campo.
  // Caso exista, compara o valor atual com o valor original.
  // Para 'requerimentoPeriodos', a comparação utiliza a validação específica da coleção.
  // Se o valor tiver retornado ao original, a exigência deverá ser resetada
  // para o estado de não atendida pelo código chamador.
  verificarSeExigenciaFoiCumpridaAnteriormente(campo) {
    const { requerimento } = { ...this.state };
    const { requerimentoVindoDoRequest } = { ...this.state };
    let { listaExigenciasAtendidas } = { ...this.state };
    let exigencia = null;
    let valorVoltouAoOriginal = false;
    const tipoExigencia = campo && campo.tipo ? campo.tipo : null;
    const atributoCampo = (campo.atributo ? campo.atributo : campo);

    for (let i = 0; i < listaExigenciasAtendidas.length; i++) {
      const exigenciaAtual = listaExigenciasAtendidas[i];
      const ehMesmaExigenciaPorTipo  = tipoExigencia !== null && exigenciaAtual.tipo === tipoExigencia;
      const ehMesmoCampoAlterado  = tipoExigencia === null && exigenciaAtual.atributo === atributoCampo;

      if (ehMesmaExigenciaPorTipo  || ehMesmoCampoAlterado ) {
        exigencia = exigenciaAtual;
        break;
      }
    }  
    
    if (exigencia) {
      // testar se o valor mudou
      if (atributoCampo === 'requerimentoPeriodos') {
        const { periodosOriginais } = { ...this.state };
        let campoRequerimentoVindoDoRequest = periodosOriginais;
        const deveValidarTempoDescontado = exigencia.tipo === EXIGENCIA_PERIODOS_ORIGEM;
        let houveAlteracao = this.verificarMudancaNaColecaoDePeriodos(campoRequerimentoVindoDoRequest, requerimento[atributoCampo], deveValidarTempoDescontado);
        if (!houveAlteracao) {
          valorVoltouAoOriginal = true;
        }

      } else {
        if (requerimento[atributoCampo] === requerimentoVindoDoRequest[atributoCampo]) {
          valorVoltouAoOriginal = true;
        }
      }
    }
    return {
      deveResetar: valorVoltouAoOriginal,
      exigencia
    };
  }

  verificaAlteracaoCamposEstadoExigencia = () => {
    // requerimento que está sendo manipulado.
    const { requerimento } = { ...this.state };
    // requerimento que está salvo na tabela.
    const { requerimentoVindoDoRequest } = { ...this.state };
    const camposExigencia = [
      'destinatario', 'idUOMantenedora', 'nome', 'nit',
      'dataNascimento', 'sexo', 'nomeMae', 'matricula',
      'numeroBeneficio', 'tipoAposentadoria', 'dataInicioBeneficio',
      'dataInicioPagamentoBeneficio', 'dataCessacaoBeneficio',
      'tempoContribuicaoTotalDias', 'tempoContribuicaoRegimeOrigemDias',
      'rendaMensalInicial', 'dataIngresso', 'dataDesvinculacao',
      'dataHomologacaoTribunalContas', 'dataCreditoPagamento',
      'regraDeCalculo', 'requerimentoPeriodos', 'arquivos', 'motivoCessacaoManual',
    ];

    if (requerimentoVindoDoRequest !== null && requerimento !== null) {
      let lista = [];
      camposExigencia.forEach((exigencia) => {
        let campoRequerimento = requerimento[exigencia];
        let campoRequerimentoVindoDoRequest = requerimentoVindoDoRequest[exigencia];

        if (exigencia === 'destinatario') {
          campoRequerimento = requerimento[exigencia];
          if (campoRequerimento !== null) {
            campoRequerimento = requerimento[exigencia].codigo;
          }
          campoRequerimentoVindoDoRequest = requerimentoVindoDoRequest[exigencia];
          if (campoRequerimentoVindoDoRequest !== null) {
            campoRequerimentoVindoDoRequest = requerimentoVindoDoRequest[exigencia].codigo;
          }
        }
        if (exigencia === 'requerimentoPeriodos') {
          const { periodosOriginais } = { ...this.state };
          campoRequerimentoVindoDoRequest = periodosOriginais;
        }

        switch (exigencia) {
          case 'destinatario':
            if (this.validarCamposNulo(campoRequerimento) && this.validarCamposNulo(campoRequerimentoVindoDoRequest) &&
              this.verificarMudancaNoValorDoCampo(campoRequerimentoVindoDoRequest, campoRequerimento)) {
              lista.push(exigencia);
            }
            break;
          case 'requerimentoPeriodos':
            if (this.verificarMudancaNaColecaoDePeriodos(campoRequerimentoVindoDoRequest, campoRequerimento, true)) {
              lista.push(exigencia);
            }
            break;
          case 'arquivos':
            if (this.validarCamposColecaoVazio(campoRequerimento)) {
              lista.push(exigencia);
            }
            break;
          default:
            if (this.validarCamposNulo(campoRequerimento) && this.validarCamposNulo(campoRequerimentoVindoDoRequest)) {
              if (this.verificarMudancaNoValorDoCampo(campoRequerimentoVindoDoRequest, campoRequerimento)) {
                lista.push(exigencia);
              }
            }
            break;
        }
      });
      return lista;
    }
  }

  verificaAlteracaoCamposQueNaoSaoExigencia = () => {
    // requerimento que está sendo manipulado.
    const { requerimento } = { ...this.state };
    // requerimento que está salvo na tabela.
    const { requerimentoVindoDoRequest } = { ...this.state };
    const camposNaoExigencia = [
      'protocoloCertidao',
      'tipoSegregacaoSolicitante',
      'tipoSegregacaoDestinatario',
    ];
    if (requerimentoVindoDoRequest !== null && requerimento !== null) {
      let lista = [];
      camposNaoExigencia.forEach((campo) => {
        let campoRequerimento = requerimento[campo];
        let campoRequerimentoVindoDoRequest = requerimentoVindoDoRequest[campo];

        if (['tipoSegregacaoSolicitante', 'tipoSegregacaoDestinatario'].includes(campo)) {
          if (this.validarCamposUndefined(campoRequerimentoVindoDoRequest)) {
            if (this.verificarMudancaNoValorDoCampo(campoRequerimentoVindoDoRequest, campoRequerimento)) {
              lista.push(campo);
            }
          } else {
            if (this.verificarMudancaNoValorDoCampo(campoRequerimentoVindoDoRequest, campoRequerimento)) {
              lista.push(campo);
            }
          }
        } else {
          if (this.validarCamposNulo(campoRequerimento) && this.validarCamposNulo(campoRequerimentoVindoDoRequest)) {
            if (this.verificarMudancaNoValorDoCampo(campoRequerimentoVindoDoRequest, campoRequerimento)) {
              lista.push(campo);
            }
          }
        }
      });
      return lista;
    }
  }

  existeConcomitanciaRegimes = (lista) => {
    const formatos = ["DD/MM/YYYY", "DD/MM/YY"];

    if (!Array.isArray(lista) || lista.length === 0) {
      return { existeConcomitancia: false };
    }

    // Apenas itens ativos (não descartados)
    const ativos = lista.filter(item => item.tipoConcomitanteDescartado !== 1);

    const ordenados = [...ativos].sort((a, b) =>
      moment(a.dataInicio, formatos, true).diff(moment(b.dataInicio, formatos, true))
    );

    for (let i = 0; i < ordenados.length - 1; i++) {
      const atualFim = moment(ordenados[i].dataFim, formatos, true);
      const proxInicio = moment(ordenados[i + 1].dataInicio, formatos, true);

      if (proxInicio.isSameOrBefore(atualFim)) {
        return { existeConcomitancia: true };
      }
    }

    return { existeConcomitancia: false };
  };


  existeConcomitanciaRemuneracoes = (lista) => {
    // Função que detecta pares mes/ano duplicados (sobrepostos)
    const vistos = {};     // Armazena combinações já vistas
    const duplicados = []; // Armazena entradas que se repetem
    let retorno = false;

    for (const item of lista) {
      const chave = `${item.mes}-${item.ano}`;
      if (vistos[chave]) {
        duplicados.push(item);  // Achou sobreposição
      } else {
        vistos[chave] = true;
      }
    }
    if (duplicados.length > 0) {
      retorno = true;
    }
    return retorno;
  }

  carregarListaRegimes = (lista) => {
    const retorno = [];
    lista.forEach((relacao) => {
      if (relacao.regimePrevidenciario) {
        relacao.regimePrevidenciario.forEach((regime) => {
          retorno.push(regime);
        });
      }
    });
    return retorno;
  }

  carregarRemuneracoes = (lista) => {
    const retorno = [];
    const ativos = lista.filter(item => item.tipoConcomitanteDescartado !== 1);
    ativos.forEach((regime) => {
      if (regime.remuneracoes) {
        regime.remuneracoes.forEach((remuneracao) => {
          retorno.push(remuneracao);
        });
      }
    });
    return retorno;
  }

  atualizarVinculosConcomitantesConfirmado = (resultado) => {
    if (!resultado.datasValidas) {
      return;
    }

    this.setState({
      vinculosConcomitantesConfirmado: true,
      possuiVinculosConcomitantes: resultado.existeConcomitancia,
    });
  };

  validacaoDeVinculosConcomitantes = () => {
    const { requerimento } = this.state;
    const listaDeRelacoes = (requerimento && requerimento.relacoesPrevidenciariasDestinatario) || [];

    if ((this.state.requerimento && this.state.requerimento.destinatario) &&
      this.state.requerimento.destinatario.codigo === '01000') {
      return { datasValidas: true, existeConcomitancia: false };
    }

    if (listaDeRelacoes.length <= 1) {
      return { datasValidas: true, existeConcomitancia: false };
    }

    const listaRegimes = this.carregarListaRegimes(listaDeRelacoes);

    // valida integridade das datas
    const integridade = this.validarDatasRegimes(listaRegimes);
    if (!integridade.valido) {
      return { datasValidas: false, existeConcomitancia: false, mensagemErro: integridade.mensagemErro };
    }

    // verifica concomitância dos regimes
    const concomitancia = this.existeConcomitanciaRegimes(listaRegimes);

    if (!concomitancia.existeConcomitancia) {
      const listaRemuneracoes = this.carregarRemuneracoes(listaRegimes);
      const concomitanciaRemuneracoes = this.existeConcomitanciaRemuneracoes(listaRemuneracoes);
      return { datasValidas: true, existeConcomitancia: concomitanciaRemuneracoes };
    }

    return { datasValidas: true, existeConcomitancia: true };
  };

  peloMenosUmVinculoSelecionado = () => {
    const colecao = this.state.requerimento.relacoesPrevidenciariasDestinatario;
    const regimes = colecao.map(e => e.regimePrevidenciario).flat();
    if ((this.state.requerimento && this.state.requerimento.destinatario) &&
      this.state.requerimento.destinatario.codigo === '01000') {
      return true;
    } else if (regimes.length > 1) {
      const regimesSelecionados = regimes.filter(e => e.tipoConcomitanteDescartado === 0);
      return regimesSelecionados.length >= 1;
    }
    return true;
  }

  validarDatasRegimes = (lista) => {
    const formatos = ["DD/MM/YYYY", "DD/MM/YY"];

    if (!Array.isArray(lista)) {
      return { valido: false, mensagemErro: "Vínculos inválidos. Verifique a aba Relações Previdenciárias Regime Origem"};
    }

    // Ordena os períodos por data de início sem alterar o array original
    const ordenados = [...lista].sort((a, b) =>
      moment(a.dataInicio, formatos, true).diff(moment(b.dataInicio, formatos, true))
    );

    // Valida cada período individualmente
    for (let i = 0; i < ordenados.length; i++) {
      const periodo = ordenados[i];
      const inicio = moment(periodo.dataInicio, formatos, true);
      const fim = moment(periodo.dataFim, formatos, true);

      if ((!inicio.isValid() || !fim.isValid()) && periodo.tipoConcomitanteDescartado === 0) {
        return { valido: false, mensagemErro: `Data no formato inválido do vínculos ${periodo.dataInicio} a ${periodo.dataFim}. Verifique a aba "Relações Previdenciárias Regime Origem"`};
      }

      if ((inicio.isAfter(fim)) && periodo.tipoConcomitanteDescartado === 0) {
        return { valido: false, mensagemErro: `Data de início do vínculo ${periodo.dataInicio} a ${periodo.dataFim} deve ser menor que a data fim. Verifique a aba "Relações Previdenciárias Regime Origem"`};
      }
    }

    return { valido: true };
  };

  /**
   * Verifica se analise foi preenchida corretamente
   */
  verificaSeAnaliseCompleta = () => {
    switch (this.state.requerimento.estado) {
      case 2: return this.state.requerimento.exigencias.length > 0;
      case 8: {
        const resultado = this.validacaoDeVinculosConcomitantes();
        const temPeloMenosUmVinculo = this.peloMenosUmVinculoSelecionado();

        // erro de dados → bloqueia botão e mostra mensagem
        if (!resultado.datasValidas) {
          trataMensagensErro([resultado.mensagemErro || 'Vínculos no formato inválido']);
          return false;
        }

        return !resultado.existeConcomitancia && temPeloMenosUmVinculo && this.state.vinculosConcomitantesConfirmado;
      }
      case 9: return this.state.motivosIndeferimentoControle.length > 0;
      case 10: return typeof this.state.requerimento.motivo === 'number';
      default: return false;
    }
  }

  isDestinatarioRGPS = (changeObj) => {
    return changeObj && changeObj.value === '01000';
  };

  isSolicitanteRGPS = () => {
    return User.logged().isRGPS();
  };

  handleChangeExigirQualificacao = (changeObj) => {
    this.setState({
      checkExigirQualificacao: changeObj.value,
    });
  }

  handleChangeTempoROManual = (changeObj, checkTempoRO) => {
    const { requerimento } = { ...this.state };
    this.setState({
      requerimento: {
        ...requerimento,
        alteracaoTempoRO: changeObj.value,
      },
      historyCheckTempoRO: checkTempoRO,
    });
  }

  handleChangeCtcEspecifica = (changeObj) => {
    const { requerimento } = { ...this.state }
    this.setState({
      requerimento: {
        ...requerimento,
        ctcEspecifica: changeObj.value,
      }
    });
  }

  /**
   * Trata o estado do formulario e alteracoes de campos.
   * Formulario deve ser considerado:
   *  - Inicial quando ainda nao enviado para validacao de regras no servico;
   *  - Alterado quando formulario montado com dados do servico e ao menos um campo foi alterado.
   *  - Enviado quando o formulario foi enviado para validacao no servico.
   */
  handleChange = (changeObj, name, callback = null) => {

    let { estadoFormulario } = { ...this.state };
    let callbackFinal = null;
    const { requerimento } = { ...this.state };
    let valido = changeObj.isValid;
    let destinatarioIndeferido = {};
    let destinatarioExigencia = {};

    if (this.state.acao === 'cumprir-exigencia') {
      estadoFormulario = 'alterado';
      const { requestPesquisa } = { ...this.state };
      let { listaExigenciasAtendidas } = { ...this.state };
      if (requestPesquisa) {
        this.setState({ requestPesquisa: false });
      }
      requerimento.exigencias.forEach((exigencia) => {
        if (exigencia.atributo) {
          if (exigencia.atributo === name && exigencia.atendida === 0) {
            exigencia.atendida = 1;
            listaExigenciasAtendidas.push(exigencia);
          }
        } else {
          // IB557704 uploads em exigencia
          if (
            name === 'arquivos'
            && Array.isArray(changeObj.value)
            && changeObj.value.length > 0
          ) {
            const possuiDocumento =
              changeObj.value.some(
                arquivo =>
                  arquivo.tipoDocumento
                  === exigencia.tipoDocumento,
              );

            if (possuiDocumento) {
              exigencia.atendida = 1;

              listaExigenciasAtendidas.push(
                exigencia,
              );
            }
          }
        }
      });
      this.setState({ listaExigenciasAtendidas });
      if (name === 'destinatario') {
        destinatarioExigencia = {
          codigo: changeObj.value,
        }
      }
    } else if (this.state.acao === 'novo' && estadoFormulario === 'erro-regra') {
      estadoFormulario = 'alterado';
    }
    // else if (this.state.acao === 'complementar-aposentadoria') {
    //   const { validadeCampos } = { ...this.state };
    //   validadeCampos.dataHomologacaoTribunalContas = true;
    // }

    if (name === 'arquivos' && this.state.acao !== 'consulta') {
      valido = true;
    } else if (name === 'arquivos' && this.state.acao === 'consulta') {
      if (valido) {
        this.setState({ habilitarBotaoCarregarDocumento: true });
      } else {
        this.setState({ habilitarBotaoCarregarDocumento: false });
      }
    }

    if (name === 'cpf' && valido) {
      callbackFinal = this.handleSearchButton;
    }

    if (name === 'destinatario') {
       // --- NOVA LÓGICA PARA LIMPAR DESTINATARIO_ORIGEM ---
      const orgaoSelecionado = this.props.destinatarios && this.props.destinatarios.find(
      item => item.value === changeObj.value
      );
      if (orgaoSelecionado && !orgaoSelecionado.codigoOrgaoCentralizador) {
      this.state.requerimento.destinatarioOrigem = null;
      }
      const { validadeCampos } = { ...this.state };
      validadeCampos.solicitanteOrigem = true;
      let { exibirCampoUoInss } = { ...this.state };
      if (this.isDestinatarioRGPS(changeObj) || this.isSolicitanteRGPS(changeObj)) {
        exibirCampoUoInss = true;
      } else {
        exibirCampoUoInss = false;
      }
      this.setState({
        exibirCampoUoInss,
      });

      // INICIO - Alteração IB 292641
      // LIMPAR O CAMPO DESTINATARIO ORIGEM SE ESTIVER PREENCHIDO
      if (this.state.acao === 'novo' && (!this.isDestinatarioRGPS(changeObj) && !this.isSolicitanteRGPS(changeObj))) {
        validadeCampos.regraDeCalculo = false;
      } else if (this.state.acao === 'novo' && (this.isDestinatarioRGPS(changeObj) && !this.isSolicitanteRGPS())) {
        validadeCampos.regraDeCalculo = true;
      } else if (this.state.acao === 'cumprir-exigencia') {

        const orgao = this.props.destinatarios.find(item => item.value === changeObj.value);

        if (this.isDestinatarioRGPS(changeObj) && !this.isSolicitanteRGPS()) {
          // DESTINATARIO = RGPS E SOLICITANTE = RPPS
          // if (!orgao.codigoOrgaoCentralizador) {
          requerimento.destinatarioOrigem = { codigo: '' };
          // }
        }
        // INICIO IB362835 - Não exibir o campo destinatario Origem se o
        // destinatário escolhido na combobox não for órgão centralizador.
        if ((!this.isDestinatarioRGPS(changeObj)) && this.isSolicitanteRGPS()) {
          // DESTINATARIO = RPPS E SOLICITANTE = RGPS
          if (orgao && (!orgao.codigoOrgaoCentralizador)) {
            requerimento.destinatarioOrigem = { codigo: '' };
          }
        }
        // FIM IB362835 - Não exibir o campo destinatario Origem se o
        // destinatário escolhido na combobox não for órgão centralizador.
        if ((!this.isDestinatarioRGPS(changeObj) && !this.isSolicitanteRGPS())) {
          // DESTINATARIO = RPPS E SOLICITANTE = RPPS
          if (requerimento.regraDeCalculo === null) {
            validadeCampos.regraDeCalculo = false;
          }
          // LIMPAR A CAIXA DE TEXTO DESTINATARIO ORIGEM QUE APARECE DESABILITADA
          if (requerimento.destinatarioOrigem) {
            requerimento.destinatarioOrigem.nome = '';
          }
          // ATUALIZAR O DESTINATARIO E O DESTINATARIO ORIGEM
          if (orgao && orgao.codigoOrgaoCentralizador) {
            requerimento.destinatarioOrigem = { codigo: orgao.value };
            requerimento.destinatario = { codigo: orgao.codigoOrgaoCentralizador };
          } else {
            requerimento.destinatarioOrigem = { codigo: '' };
          }
        }
      }
      // FIM - Alteração IB 292641
    }

    if (name === 'destinatario' && this.state.acao === 'indeferidos') {
      destinatarioIndeferido = {
        codigo: changeObj.value,
      };
    }

    if (name === 'rendaMensalInicial') {
      if (changeObj.value === '') {
        valido = false;
      }
    }
    // se for verdadeiro quer dizer que uma ctc foi pesquisada anteriormente.
    if (name === 'protocoloCertidao' && valido) {
      const { requestPesquisa } = { ...this.state };
      const { validadeCampos } = { ...this.state };
      if (requestPesquisa && requestPesquisa === 'protocoloCertidao') {
        validadeCampos.requerimentoPeriodos = false;
      }
    }

    if (name === 'tempoContribuicaoRegimeOrigemDias' && valido) {
      const { exigenciasInvalidas } = { ...this.state };
      requerimento.exigencias.forEach((exigencia) => {
        const paramAtributo = exigencia.atributo;
        if (paramAtributo && exigencia.atendida === 1) {
          if (paramAtributo in this.state.exigenciasInvalidas) {
            exigenciasInvalidas.tempoContribuicaoRegimeOrigemDias = false;
            this.setState({ exigenciasInvalidas });
          }
        }
      });
    }
    if (
      (name === 'motivoCessacaoManual' || name === 'dataCessacaoBeneficio') &&
      (changeObj.value === '' || changeObj.value === null)
    ) {
      valido = true;
    }
    if (name === 'motivoCessacaoManual') {
        // Se for string vazia, converte para null (caso ele clique em Selecione...)
        //evita erro de conversao para integer no backend
        if (changeObj.value === '' || changeObj.value === undefined) {
          changeObj.value = null;
          valido = true; // Campo vazio é considerado válido
        }
    }
    if (!callbackFinal) {
      callbackFinal = callback;
    }

    const dataMotivoValido = this.isDataMotivoValido({
      ...this.state,
      requerimento: {
        ...requerimento,
        [name]: changeObj.value
      }
    });
    this.setState({
      requerimento: {
        ...requerimento,
        [name]: destinatarioIndeferido.codigo ? destinatarioIndeferido : changeObj.value,
        [name]: destinatarioExigencia.codigo ? destinatarioExigencia : changeObj.value,
      },
      validadeCampos: {
        ...this.state.validadeCampos,
        [name]: valido,
        dataMotivoCessacao: dataMotivoValido,
      },
      estadoFormulario,
    }, callbackFinal);
  }

  atualizarMotivoCessacaoManual = () => {

  }

  handleClick = (changeObj, name) => {
    let paramExibirBotaoVoltar;    
    switch (name) {
      case 'item2':
        this.addMotivoCessacaoManualLabel(this.state.requerimento.motivoCessacaoManual);
        paramExibirBotaoVoltar = true;
        break;
      case 'item3':
        paramExibirBotaoVoltar = false;
        break;
      default:
        paramExibirBotaoVoltar = true;
        break;
    }
    // if (name === 'item3') {
    //   paramExibirBotaoVoltar = false;
    // } else {
    //   paramExibirBotaoVoltar = true;
    // }
    this.setState({
      exibirBotaoVoltar: paramExibirBotaoVoltar,
    });
  }

  handleKeyUp = (e) => {
    let retorno = e.target.value;
    if (retorno.indexOf('_') !== -1) {
      retorno = retorno.toString().replace('_', '');
    }
    retorno = retorno.toString().replace(/\D/g, '');
    retorno = retorno.toString().replace(/(\d)(\d{11})$/, '$1.$2');
    retorno = retorno.toString().replace(/(\d)(\d{8})$/, '$1.$2');
    retorno = retorno.toString().replace(/(\d)(\d{5})$/, '$1.$2');
    retorno = retorno.toString().replace(/(\d)(\d{2})$/, '$1,$2');
    e.target.value = retorno;

    return retorno;
  }

  /**
   * Trata o click no botão de busca por CPF no CNIS.
   */
  handleSearchButton = () => {
    const cpfTouched = true;
    this.setState({ ...this.state, cpfTouched }, this.handleSearch);
  }

  handleSearch = () => {
    // if (this.state.validadeCampos.cpf) {
    if (this.state.acao === 'qualificar') {
      const { validadeCampos } = { ...this.state };
      if (validadeCampos.cpf === false) {
        validadeCampos.cpf = true;
      }
      this.setState({ validadeCampos });
    }

    const { cpf } = { ...this.state.requerimento };
    this.setState(
      { requestPesquisa: 'cnis' },
      doGet(
        `pessoas-fisicas/${cpf}`,
        this.trataSucessoResponsePesquisa,
        this.trataErrosResponse,
      ),
    );
    // }
  }

  calcularPeriodoRgps = (periodo, calcularAmd) => {
    const acrescentarDia = 1;
    const acrescentarMesDias = 30;
    const trintaUm = 31;
    const qtdDiasMes = 30;
    const qtdMesesAno = 12;
    const acrescentarAno = 12;
    const reduzirMes = 1;
    const reduzirAno = 1;
    const mesFev = 2;
    const ultimoDiaFevBissexto = 29;
    const ultimoDiaFevNaoBissexto = 28;
    const acrescentarAnoDias = 365

    let resultadoDia = 0;
    let resultadoMes = 0;
    let resultadoAno = 0;
    let resultadoQtdMeses = 0;
    let restoDivisaoDia = 0;
    let resultadoQtdAnos = 0;
    let restoDivisaoMes = 0;
    let retorno = 0;
    let retornoAmd = {};

    let diaInicio = periodo.dataInicio.split('/')[0];
    let mesInicio = periodo.dataInicio.split('/')[1];
    let anoInicio = periodo.dataInicio.split('/')[2];

    let diaFim = periodo.dataFim.split('/')[0];
    let mesFim = periodo.dataFim.split('/')[1];
    let anoFim = periodo.dataFim.split('/')[2];


    if (moment([anoFim]).isLeapYear()) {
      if (Number(mesFim) === mesFev && Number(diaFim) === ultimoDiaFevBissexto) {
        diaFim = Number(diaFim) + 1;
      }
    } else {
      if (Number(mesFim) === mesFev && Number(diaFim) === ultimoDiaFevNaoBissexto) {
        diaFim = Number(diaFim) + 2;
      }
    }

    if (Number(diaFim) < trintaUm) {
      diaFim = Number(diaFim) + acrescentarDia;
      if (Number(diaInicio > diaFim)) {
        diaFim = Number(diaFim) + acrescentarMesDias;
        mesFim = Number(mesFim) - reduzirMes;
      }
    }
    resultadoDia = Number(diaFim - diaInicio);

    resultadoQtdMeses = Math.trunc(resultadoDia / qtdDiasMes);
    restoDivisaoDia = (resultadoDia % qtdDiasMes);
    resultadoDia = restoDivisaoDia;

    if (Number(mesFim < mesInicio)) {
      mesFim = Number(mesFim) + acrescentarAno;
      anoFim = Number(anoFim) - reduzirAno;
    }
    resultadoMes = Number(mesFim - mesInicio);
    resultadoMes += resultadoQtdMeses;

    resultadoQtdAnos = Math.trunc(resultadoMes / qtdMesesAno);
    restoDivisaoMes = (resultadoMes % qtdMesesAno);
    resultadoMes = restoDivisaoMes;

    resultadoAno = Number(anoFim - anoInicio);
    resultadoAno += resultadoQtdAnos;

    if (calcularAmd) {
      retornoAmd.dataInicio = periodo.dataInicio;
      retornoAmd.dataFim = periodo.dataFim;
      retornoAmd.totalDia = resultadoDia;
      retornoAmd.totalMes = resultadoMes;
      retornoAmd.totalAno = resultadoAno;
      return retornoAmd;
    } else {
      retorno = Number((resultadoAno * acrescentarAnoDias) + (resultadoMes * acrescentarMesDias) + resultadoDia);
      return retorno;
    }
  };

  calcularPeriodoRpps = (periodo) => {
    let retorno = periodo;
    let dataInicioCorrido = moment(periodo.dataInicio, 'DD/MM/YYYY');
    let dataFimCorrido = moment(periodo.dataFim, 'DD/MM/YYYY');

    const acrescentarDataFinal = 1;

    let diffDatas = (dataFimCorrido.diff(dataInicioCorrido, 'days')) + acrescentarDataFinal;
    retorno = diffDatas;

    return retorno;
  };

  // IB422810 - INICIO SUBPERIODOS
  atualizarDataIngressoDesvinculacaoETempoPorAcao = (lista, origem) => {
    const { requerimento } = { ...this.state };
    let { historyTempoRO } = { ...this.state };

    let existePeriodo = false;
    if (lista && lista.length > 0) {
      lista = this.ordenarListaPeriodos(lista);
      let primeiroItemDaLista = (lista && lista.length > 0) ? lista[0] : '';
      let ultimoItemDaLista = (lista && lista.length > 0) ? lista[lista.length - 1] : '';
      let dataComUmDiaAdicionado = adicionarQuantidadeAumaData(stringToData(ultimoItemDaLista.dataFim), 1, 'd');
      let somatorioTempoContribuicao = 0;
      let periodoAux = {};
      let listaAux = [];
      if (this.isRelacaoRgpsRpps(requerimento.destinatario)) {
        lista.forEach((periodo) => {
          periodoAux = this.calcularPeriodoRgps(periodo, true);
          listaAux.push(periodoAux);

          if (!periodo.operacao) {
            periodo.operacao = 0;
          }
        });
        somatorioTempoContribuicao = this.calcularTempoTotalAmdRgps(listaAux, lista);
      } else {
        lista.forEach((periodo) => {
          if (periodo.qtdDiasContribuicaoLiquido) {
            somatorioTempoContribuicao += periodo.qtdDiasContribuicaoLiquido;

            if (!periodo.operacao) {
              periodo.operacao = 0;
            }
          }
        });
      }
      requerimento.dataIngresso = primeiroItemDaLista.dataInicio;
      requerimento.dataDesvinculacao = dataComUmDiaAdicionado.format('DD/MM/YYYY');
      requerimento.tempoContribuicaoRegimeOrigemDias = somatorioTempoContribuicao;
      historyTempoRO = somatorioTempoContribuicao;
      existePeriodo = true;
    } else {
      existePeriodo = false;
    }
    if (origem && origem === 3) {
      const { requerimentoVindoDoRequest } = { ...this.state }
      if ((requerimentoVindoDoRequest) && (lista.length === 0)) {
        requerimento.dataIngresso = requerimentoVindoDoRequest.dataIngresso;
        requerimento.dataDesvinculacao = requerimentoVindoDoRequest.dataDesvinculacao;
        requerimento.tempoContribuicaoRegimeOrigemDias = requerimentoVindoDoRequest.tempoContribuicaoRegimeOrigemDias;
      } else if ((!requerimentoVindoDoRequest) && (lista.length === 0)) {
        requerimento.dataIngresso = null;
        requerimento.dataDesvinculacao = null;
        requerimento.tempoContribuicaoRegimeOrigemDias = null;
      }
    }
    if (origem) {
      this.cumprirExigenciaDataIngressoDesvinculacaoETempo();
    }
    this.setState({
      requerimento: {
        ...requerimento,
      },
      validadeCampos: {
        ...this.state.validadeCampos,
        requerimentoPeriodos: existePeriodo,
      },
      historyTempoRO: historyTempoRO,
    });
  }

  marcarExigenciaInvalidaDataIngressoDesvinculacaoETempoRO = () => {
    const { requerimento } = { ...this.state }
    const { exigenciasInvalidas } = { ...this.state };
    if (requerimento.exigencias) {
      requerimento.exigencias.forEach((item) => {
        if (item.atributo) {
          if (['tempoContribuicaoRegimeOrigemDias', 'dataIngresso', 'dataDesvinculacao'].includes(item.atributo)) {
            exigenciasInvalidas[item.atributo] = true;
          }
        }
      });
    }
    this.setState({
      exigenciasInvalidas,
    });
  }

  cumprirExigenciaDataIngressoDesvinculacaoETempo = () => {
    const { requerimento } = { ...this.state }
    const { exigenciasInvalidas } = { ...this.state };
    const { validadeCampos } = { ...this.state };
    const { acao } = { ...this.state };
    let { listaExigenciasAtendidas } = { ...this.state };

    if (requerimento.exigencias) {
      if (acao === 'cumprir-exigencia') {
        let lista = this.verificaAlteracaoCamposEstadoExigencia();
        if (lista !== undefined) {
          lista.forEach((item) => {
            const index = requerimento.exigencias.findIndex(i => (i.atributo === item));
            if (index !== -1) {
              if (['tempoContribuicaoRegimeOrigemDias', 'dataIngresso', 'dataDesvinculacao', 'requerimentoPeriodos'].includes(item)) {
                requerimento.exigencias[index].atendida = 1;
                exigenciasInvalidas[item] = false;
                // validadeCampos[item] = true;
                const i = listaExigenciasAtendidas.findIndex(exAtend => (exAtend.atributo === item));
                if (i === -1) {
                  listaExigenciasAtendidas.push(requerimento.exigencias[index]);
                }
              }
            }
          });
        }
      } else {
        requerimento.exigencias.forEach((item) => {
          if (item.atributo) {
            if (['tempoContribuicaoRegimeOrigemDias', 'dataIngresso', 'dataDesvinculacao'].includes(item.atributo)) {
              item.atendida = 1;
              exigenciasInvalidas[item.atributo] = false;
              // validadeCampos[item.atributo] = true;
              listaExigenciasAtendidas.push(item);
            }
          }
        });
      }
    }

    this.setState({
      requerimento: {
        ...requerimento,
      },
      exigenciasInvalidas,
      listaExigenciasAtendidas,
      validadeCampos,
    });
  }

  atualizarDataIngressoDesvinculacaoETempo = (lista, origem) => {
    const { acao } = { ...this.state }
    switch (acao) {
      case 'novo': {
        this.atualizarDataIngressoDesvinculacaoETempoPorAcao(lista, origem);
        break;
      }
      case 'cumprir-exigencia': {
        this.atualizarDataIngressoDesvinculacaoETempoPorAcao(lista, origem);
        break;
      }
      case 'indeferidos': {
        this.atualizarDataIngressoDesvinculacaoETempoPorAcao(lista, origem);
        break;
      }
      case 'complementar-aposentadoria': {
        this.atualizarDataIngressoDesvinculacaoETempoPorAcao(lista, origem);
        break;
      }
      // case 'realizar-analise': {
      //   this.atualizarDataIngressoDesvinculacaoETempoPorAcao(lista, origem);
      //   break;
      // }
      default:
        break;
    }
  }

  controlarExibicaoMultiplosPeriodos = () => {
    let { exibirMultiplosPeriodos } = { ...this.state }
    const { requerimentoPeriodos } = { ...this.state.requerimento }
    const { acao } = { ...this.state }
    const possuiPeriodos = (requerimentoPeriodos && requerimentoPeriodos.length > 0);
    // if (this.isSolicitanteRGPS()) {
    switch (acao) {
      case 'novo':
        exibirMultiplosPeriodos = true;
        break;
      case 'cumprir-exigencia':
        exibirMultiplosPeriodos = true;
        break;
      case 'realizar-analise':
        if (possuiPeriodos) {
          exibirMultiplosPeriodos = true;
          break;
        }
        exibirMultiplosPeriodos = false;
        break;
      case 'complementar-aposentadoria':
        exibirMultiplosPeriodos = true;
        break;
      case 'qualificar':
        if (possuiPeriodos) {
          exibirMultiplosPeriodos = true;
        }
        break;
      case 'indeferidos':
        exibirMultiplosPeriodos = true;
        break;
      case 'consulta':
        if (possuiPeriodos) {
          exibirMultiplosPeriodos = true;
          break;
        }
        break;
      default:
        break;
    }
    // } else {
    //   exibirMultiplosPeriodos = true;
    // }
    this.setState({ exibirMultiplosPeriodos });
  }

  handleSearchPeriodos = () => {
    const protocoloCertidaoTouched = true;
    this.setState({ ...this.state, protocoloCertidaoTouched }, this.recuperarPeriodosCtc);
  }

  trataSucessoResponsePeriodosCtc = (response) => {
    //alterar o atributo periodos pelo nome response
    const { requerimentoPeriodos } = { ...this.state.requerimento };
    let { requerimento } = { ...this.state };
    let { acao } = { ...this.state };
    if (acao !== 'complementar-aposentadoria') {
      requerimento.protocoloCertidao = response.data.protocoloCertidao ? response.data.protocoloCertidao : '';
    }
    this.setState({
      requerimento: {
        ...requerimento,
      },
      duplaDestinacao: response.data.duplaDestinacao
    });

    if (response.data.periodos && response.data.periodos.length > 0 && requerimentoPeriodos.length > 0) {
      // exibe o modal de confirmação de substituicao dos peridos
      const texto = msgConfirmacaoRequerimentosPeriodos.descricao;
      const alerta = { descricao: texto };
      this.setState({
        requerimentosPeriodosVindosDoRequest: response.data.periodos,
        clicouBotaoPesquisarCtc: true,
        alertas: [alerta],
        showModalAlertaRequerimentosPeriodos: !this.state.showModalAlertaRequerimentosPeriodos,
        requerimento: {
          ...requerimento,
          tempoContribuicaoRegimeOrigemDias: response.data.tempoCertificado,
        },
        historyTempoRO: response.data.tempoCertificado,
      });
    } else if (response.data.periodos && response.data.periodos.length > 0 && requerimentoPeriodos.length === 0) {
      // substitui os periodos cadastrados anteriormente pelo usuario e substitui pelos periodos que vieram do servico
      this.setState({
        requerimentosPeriodosVindosDoRequest: response.data.periodos,
        clicouBotaoPesquisarCtc: true,
      }, this.substituirRequerimentosPeriodos(response.data));
    } else if (response.data.periodos && response.data.periodos.length === 0) {
      trataMensagensErro([`Não foram encontrados períodos para o protocolo da certidão pesquisado.`]);
    }
  }

  compararDatasInicio = (a, b) => {
    if (moment(a.dataInicio, 'DD/MM/YYYY').toDate() < moment(b.dataInicio, 'DD/MM/YYYY').toDate()) {
      return -1;
    }
    if (moment(a.dataInicio, 'DD/MM/YYYY').toDate() > moment(b.dataInicio, 'DD/MM/YYYY').toDate()) {
      return 1;
    }
    return 0;
  }

  ordenarListaPeriodos = (lista) => {
    lista.sort(this.compararDatasInicio);
    return lista;
  }

  alteraListaAposExclusao = (listaPeriodos, origem) => {
    this.atualizarDataIngressoDesvinculacaoETempo(listaPeriodos, origem);
    this.handleFechamentoModalAlertaRequerimentosPeriodos();
  }

  calcularTempoDeContribuicaoBruto = (periodo) => {
    let retorno = '';
    if (periodo) {
      if ((periodo.dataInicio && periodo.dataInicio.indexOf('_') === -1) &&
        (periodo.dataFim && periodo.dataFim.indexOf('_') === -1)) {
        const data1 = moment(periodo.dataInicio, 'DD/MM/YYYY');
        const data2 = moment(periodo.dataFim, 'DD/MM/YYYY');
        const diferenca = data2.diff(data1, 'days');
        retorno = (Number(diferenca) + 1);
        return retorno;
      } else {
        let { requerimento } = { ...this.state };
        retorno = requerimento.tempoContribuicaoRegimeOrigemDias;
      }
    }
    return retorno;
  }

  substituirRequerimentosPeriodos = (data) => {
    //inserir os periodos novos na lista
    let { requerimento } = { ...this.state };
    let { requerimentoPeriodos } = { ...this.state.requerimento };
    let { requerimentoPeriodosExcluidos } = { ...this.state.requerimento };
    let { requerimentosPeriodosVindosDoRequest } = { ...this.state };
    let { listaExigenciasAtendidas } = { ...this.state };
    let { exigenciasInvalidas } = { ...this.state };
    let { historyTempoRO } = { ...this.state };
    let resultadoExclusao = [];
    let periodosResponse = [];

    if (requerimentosPeriodosVindosDoRequest.length > 0) {
      requerimentosPeriodosVindosDoRequest.forEach((item) => {
        let periodos = {};
        periodos.dataInicio = item.dataInicio;
        periodos.dataFim = item.dataFim;
        periodos.qtdDiasDesconto = 0;

        periodosResponse.push(periodos);
      })
    } else {
      data.periodos.forEach((item) => {
        let periodos = {};
        periodos.dataInicio = item.dataInicio;
        periodos.dataFim = item.dataFim;
        periodos.qtdDiasDesconto = 0;

        periodosResponse.push(periodos);
      })
    }

    let periodosComId = [];
    requerimentoPeriodos.forEach((periodo) => {
      if (periodo.idPeriodo) {
        periodosComId.push(periodo);
      }
    });
    requerimentoPeriodos = periodosComId;

    const houveAlteracaoPeriodos = this.verificarMudancaNaColecaoDePeriodos(requerimentoPeriodos, periodosResponse, true);
    if (houveAlteracaoPeriodos) {
      requerimento.exigencias
        .filter(ex => ex.atributo === 'requerimentoPeriodos')
        .forEach(ex => { 
          ex.atendida = 1;

          if (!listaExigenciasAtendidas.some(e => e.tipo === ex.tipo)) {
            listaExigenciasAtendidas.push(ex);
          }
        });
      //limpar a coleção de exclusões.
      requerimentoPeriodosExcluidos = [];
      //incluir os periodos que vêm da lista de periodos da tabela do bd na lista de periodos excluídos.
      requerimentoPeriodos.forEach((periodo) => {
        requerimentoPeriodosExcluidos.push(periodo);
      });
      resultadoExclusao = requerimentoPeriodosExcluidos;

      if (data.periodos) {
        requerimentosPeriodosVindosDoRequest = data.periodos;
      }

      requerimentosPeriodosVindosDoRequest.forEach((periodo) => {
        if (!periodo.operacao) {
          periodo.operacao = 1;
        }
      });

      let resultado = requerimentosPeriodosVindosDoRequest;
      resultado = this.ordenarListaPeriodos(resultado);
      let existePeriodo = false;

      let primeiroItemDaLista = (resultado && resultado.length > 0) ? resultado[0] : '';
      let ultimoItemDaLista = (resultado && resultado.length > 0) ? resultado[resultado.length - 1] : '';

      let dataComUmDiaAdicionado = adicionarQuantidadeAumaData(stringToData(ultimoItemDaLista.dataFim), 1, 'd');
      let somatorioTempoContribuicao = 0;
      if (this.state.requestPesquisa === 'periodosCtc') {
        if (data.periodos) {
          requerimento.tempoContribuicaoRegimeOrigemDias = data.tempoCertificado;
          historyTempoRO = data.tempoCertificado;
        }
      } else {
        resultado.forEach((periodo) => {
          if (periodo.qtdDiasContribuicaoLiquido) {
            somatorioTempoContribuicao += periodo.qtdDiasContribuicaoLiquido;
          }
        });
        requerimento.tempoContribuicaoRegimeOrigemDias = somatorioTempoContribuicao;
        historyTempoRO = somatorioTempoContribuicao;
      }

      requerimento.dataIngresso = primeiroItemDaLista.dataInicio;
      requerimento.dataDesvinculacao = dataComUmDiaAdicionado.format('DD/MM/YYYY');
      existePeriodo = true;

      this.setState({
        requerimento: {
          ...requerimento,
          requerimentoPeriodos: resultado,
          requerimentoPeriodosExcluidos: resultadoExclusao,
        },
        validadeCampos: {
          ...this.state.validadeCampos,
          requerimentoPeriodos: existePeriodo,
        },
        historyTempoRO: historyTempoRO,
      }, this.acaoDeAcordoComTamanhoDoRequerimentoPeriodos(requerimentoPeriodos, requerimentosPeriodosVindosDoRequest));
    } else {
      this.handleFechamentoModalAlertaRequerimentosPeriodos();
      this.setState({
        requerimento: {
          ...requerimento,
          requerimentoPeriodos: periodosComId,
        },
      })
    }

    let lista = this.verificaAlteracaoCamposEstadoExigencia();
    if (lista !== undefined) {
      lista.forEach((item) => {
        const indice = requerimento.exigencias.findIndex(i => (i.atributo === item));
        if (indice !== -1) {
          if (['tempoContribuicaoRegimeOrigemDias'].includes(item)) {
            requerimento.exigencias[indice].atendida = 1;
            exigenciasInvalidas[item] = false;
            // validadeCampos[item] = true;
            const i = listaExigenciasAtendidas.findIndex(exAtend => (exAtend.atributo === item));
            if (i === -1) {
              listaExigenciasAtendidas.push(requerimento.exigencias[indice]);
            }
          }
        }
      });
    }
    this.setState({
      exigenciasInvalidas,
      listaExigenciasAtendidas,
    });
  }

  acaoDeAcordoComTamanhoDoRequerimentoPeriodos = (requerimentoPeriodos, requerimentosPeriodosVindosDoRequest) => {
    if (requerimentoPeriodos.length > 0 && requerimentosPeriodosVindosDoRequest.length > 0) {
      this.handleFechamentoModalAlertaRequerimentosPeriodos();
    } else if (requerimentoPeriodos.length === 0 && requerimentosPeriodosVindosDoRequest.length > 0) {
      this.cumprirExigenciaDataIngressoDesvinculacaoETempo();
      if (this.state.showModalAlertaRequerimentosPeriodos) {
        this.handleFechamentoModalAlertaRequerimentosPeriodos();
      }
    }
  }

  determinarConcomitancias = (periodos, index) => {
    let periodoAtual = periodos[index];
    for (let i = 0, tamanhoI = periodos.length; i < tamanhoI; i += 1) {
      if (index != i) {
        let periodoAux = periodos[i];
        if (stringToData(periodoAtual.dataInicio) <= stringToData(periodoAux.dataFim) && stringToData(periodoAux.dataInicio) <= stringToData(periodoAtual.dataFim)) {
          return true;
        }
      }
    }
    return false;
  }
  recuperarPeriodosCtc = () => {
    const { cpf } = { ...this.state.requerimento };
    this.setState(
      { requestPesquisa: 'periodosCtc' },
      doGet(
        `ctc/${cpf}`,
        this.trataSucessoResponsePeriodosCtc,
        this.trataErrosResponse,
      ),
    );
  }

  verificarHabilitacaoDataIngressoDesvinculacaoETempo = () => {
    let habilitar = true;
    const { requerimento } = { ...this.state }
    const { acao } = { ...this.state }
    const possuiDataInicioOuDesvinculacaoOuTempoRONulo = (requerimento.tempoContribuicaoRegimeOrigemDias === null
      || requerimento.dataIngresso === null || requerimento.dataDesvinculacao === null);
    if (this.isSolicitanteRGPS()) {
      switch (acao) {
        case 'realizar-analise':
          if (possuiDataInicioOuDesvinculacaoOuTempoRONulo) {
            habilitar = true;
            break;
          }
          habilitar = false;
          break;
        default:
          break;
      }
    }
    this.setState({ habilitarCamposParaAlteracaoNaAnalise: habilitar });
  }
  // IB422810 - FIM SUBPERIODOS

  /**
   * Trata o click no botão de busca por NIT Elados
   */
  handlePesquisaBotaoEloNit = () => {
    this.setState({ exibirModalCadeiaDeNit: true });
  }

  /**
  * Trata o click no botão de alteração da data de cessação
  */
  handleModalAlteraDataCessacao = () => {
    this.setState({ exibirModalDataCessacao: !this.state.exibirModalDataCessacao });
  }

    /**
  * Trata o click no botão de alteração da data de cessação
  */
  handleModalAlteraMotivoCessacao = () => {
    this.setState({ exibirModalMotivoCessacao: !this.state.exibirModalMotivoCessacao });
  }

     /**
  * Trata o click no botão de alteração da data de cessação e motivo juntos
  */
  handleModalAlteraDataEMotivoCessacao = () => {
    this.setState({ exibirModalDataEMotivoCessacao: !this.state.exibirModalDataEMotivoCessacao });
  }

  /**
   * Trata o fechamento do modal de NIT Elados
   */
  handleModalCadeiaDeNitModal = () => {
    this.setState({ exibirModalCadeiaDeNit: false });
  }

  /**
   * Trata o click no botão de busca por NB no BenMigrado. CentralService
   */
  handleSearchNBButton = () => {
    const numeroBeneficioTouched = true;
    this.setState({ ...this.state, numeroBeneficioTouched }, this.handleNBSearch);
  }

  /**
    * Trata o click no botão de alteração do tipo de segregação
    */
  handleModalAlteraSegregacaoMassa = (origem) => {
    this.setState({ exibirModalSegregacaoMassa: !this.state.exibirModalSegregacaoMassa, origemModalSegregacaoMassa: origem });
  }

  handleNBSearch = () => {
    if (this.state.validadeCampos.numeroBeneficio) {
      const { numeroBeneficio } = { ...this.state.requerimento };
      this.setState(
        { requestPesquisa: 'centralService' },
        doGet(
          `beneficio-rgps/${numeroBeneficio}`,
          this.trataSucessoResponsePesquisa,
          this.trataErrosResponse,
        ),
      );
    }
  }

  trataSucessoResponsePesquisa = (response) => {
    const { validadeCampos } = { ...this.state };
    const { requestPesquisa } = { ...this.state };
    // const requerimentoAtual = this.state.requerimento;
    const requerimento = this.cumpreExigenciasEmAtributosDeServico(response);

    camposPreenchidosPorServico[requestPesquisa].forEach((key) => {
      validadeCampos[key] = true;
    });

    if (requestPesquisa === 'cnis') {
      if (response.data.isObtidoPelaRFB === true) {
        if (requerimento.nit !== null) {
          requerimento.nit = null;
          validadeCampos.nit = false;
        }
        if (requerimento.sexo !== null) {
          requerimento.sexo = null;
          validadeCampos.sexo = false;
        }
      }
      if (!response.data.nome) {
        requerimento.nome = '';
      }
      if (!response.data.nit) {
        requerimento.nit = null;
        validadeCampos.nit = false;
      }
      if (!response.data.dataNascimento) {
        requerimento.dataNascimento = null;
        validadeCampos.dataNascimento = false;
      }
      if (!response.data.sexo) {
        requerimento.sexo = null;
        validadeCampos.sexo = false;
      }
      if (!response.data.nomeMae) {
        requerimento.nomeMae = '';
      }
      this.setState({
        isObtidoPelaRFB: response.data.isObtidoPelaRFB,
      });
      if (this.state.acao === 'indeferidos') {
        const { validadeBotoesIndeferidos } = { ...this.state };
        if (validadeBotoesIndeferidos.pesquisarDadosPessoais === false) {
          validadeBotoesIndeferidos.pesquisarDadosPessoais = true;
        }
        this.setState({ validadeBotoesIndeferidos });
      }
    }

    if (requestPesquisa === 'centralService') {
      // Apaga campos quando nao vierem do serviço

      if (!response.data.tipoAposentadoria) {
        requerimento.tipoAposentadoria = null;
        validadeCampos.tipoAposentadoria = false;
      }

      if (!response.data.dataInicioBeneficio) {
        requerimento.dataInicioBeneficio = null;
        validadeCampos.dataInicioBeneficio = false;
      }

      if (!response.data.dataInicioPagamentoBeneficio) {
        requerimento.dataInicioPagamentoBeneficio = null;
      }

      if (!response.data.dataCessacaoBeneficio) {
        requerimento.dataCessacaoBeneficio = null;
      }
      //IB603425
      // requerimento.dataCessacaoBeneficio = '28/01/2026';

      if (!response.data.rendaMensalInicial) {
        if (response.data.rendaMensalInicial === 0) {
          if (requerimento.rendaMensalInicial !== null) {
            requerimento.rendaMensalInicial = '';
          }
          response.data.rendaMensalInicial = null;
          validadeCampos.rendaMensalInicial = false;
          this.setState({
            isRmiZerada: true,
            rendaMensalInicialRequest: null,
          });
        }
      } else if (this.state.isRmiZerada) {
        this.setState({
          isRmiZerada: false,
        });
      }

      if (!response.data.dataCreditoPagamento) {
        requerimento.dataCreditoPagamento = null;
        // validadeCampos.dataCreditoPagamento = false;
      }

      if (!response.data.tempoContribuicaoTotalDias) {
        validadeCampos.tempoContribuicaoTotalDias = false;
        requerimento.tempoContribuicaoTotalDias = null;
      }

      if (!response.data.idUOMantenedora) {
        requerimento.idUOMantenedora = null;
        validadeCampos.idUOMantenedora = false;
      }

      if (this.state.acao === 'indeferidos') {
        const { validadeBotoesIndeferidos } = { ...this.state };
        if (validadeBotoesIndeferidos.pesquisarDadosBeneficio === false) {
          validadeBotoesIndeferidos.pesquisarDadosBeneficio = true;
        }
        this.setState({ validadeBotoesIndeferidos });
      }
    }

    const novoRequerimento = {
  ...requerimento,
  ...response.data,
  };

  validadeCampos.dataMotivoCessacao =
  this.isDataMotivoValido({
    ...this.state,
    requerimento: novoRequerimento,
  });

  this.setState({
    requerimento: novoRequerimento,
    requestPesquisa: null,
    validadeCampos,
  });
  }

  cumpreExigenciasEmAtributosDeServico = (reqResponse) => {
    // camposPreenchidosPorServico
    // cnis
    // benMigrado
    const { data } = { ...reqResponse };
    const { requerimento } = { ...this.state };
    const { exigencias } = { ...requerimento };
    const { requestPesquisa } = { ...this.state };
    
    if (this.state.acao === 'cumprir-exigencia'
      && exigencias) {
      requerimento.exigencias.forEach((exigencia) => {
        if (data[exigencia.atributo] &&
          data[exigencia.atributo] !== requerimento[exigencia.atributo]) {
          // eslint-disable-next-line
          exigencia.atendida = 1;
        }

        if (requestPesquisa === 'centralService')
        //no caso de data de cessação ter sido preenchida errada pelo usuario ou migrada errada e ela não existir no central-service
       
        if (exigencia.atributo === 'dataCessacaoBeneficio' && data[exigencia.atributo] === undefined && requerimento[exigencia.atributo] !== null) {
          exigencia.atendida = 1;
          requerimento.dataCessacaoBeneficio = null;    
        }
      });
    }
    return requerimento;
  }
  extrairMotivosParaSalvar = () => {
    const { motivosIndeferimentoControle } = { ...this.state };
    if (motivosIndeferimentoControle.length > 0) {
      const { requerimento } = { ...this.state };
      var lista = [];
      motivosIndeferimentoControle.forEach((item) => {
        lista.push(item.motivo);
      });
      requerimento.listaMotivosIndeferimento = lista;
      this.setState({ ...requerimento });
    }
  }

  resetarCumprimentoExigencias = (campo) => {
  const { requerimento } = this.state;

  const tipo = (campo && campo.tipo) ? campo.tipo : null;
  const atributoCampo = (campo && campo.atributo) ? campo.atributo : campo;

  requerimento.exigencias.forEach((exigencia) => {
    const ehMesmaExigenciaPorTipo = tipo !== null && exigencia.tipo === tipo;
    const ehMesmoAtributoCampo = tipo === null && exigencia.atributo === atributoCampo;

   if ((ehMesmaExigenciaPorTipo || ehMesmoAtributoCampo) && exigencia.atendida === 1) {
      exigencia.atendida = 0;
    }
  });

  return requerimento;
};

  resetarCumprimentoExigenciasInvalidas = (campo) => {
    const { requerimento } = { ...this.state };
    const { exigenciasInvalidas } = { ...this.state };
    let atributoCampo = (campo.atributo ? campo.atributo : campo);

    if (['tempoContribuicaoRegimeOrigemDias', 'dataIngresso', 'dataDesvinculacao'].includes(atributoCampo)) {
      const index = requerimento.exigencias.findIndex(item => (item.atributo === atributoCampo));
      if (index !== -1) {
        if (atributoCampo && campo.atendida === 1) {
          if (atributoCampo in this.state.exigenciasInvalidas) {
            exigenciasInvalidas[atributoCampo] = true;
          }
        }
      }
    }
    return exigenciasInvalidas;
  }

  /**
   * Trata o click do botao de submissao do formulario
   * Se analise estiver indeferindo, exibir alerta de confirmacao
   */
  handleSaveButton = () => {
    if (this.state.acao === 'consulta') {
      this.uploadFileAvulso();
    } else {
      if (this.state.requerimento.estado === 9) {
        this.extrairMotivosParaSalvar();
        this.setState({
          alertas: [msgsConfirmacao.indeferimento],
          showModalAlerta: !this.state.showModalAlerta,
        });
      } else if (this.state.acao === 'cumprir-exigencia') {
        let lista = this.verificaAlteracaoCamposEstadoExigencia();
        if (lista.length === 0) {
          // verificar se a exigencia foi cumprida cumprida mas voltou a ter o mesmo valor.
          let { requerimento } = { ...this.state };
          let { exigenciasInvalidas } = { ...this.state };

          const { exigencias } = { ...this.state.requerimento };
          exigencias.forEach((exigencia) => {
            const resultadoExigencia = this.verificarSeExigenciaFoiCumpridaAnteriormente(exigencia);
            if (resultadoExigencia.deveResetar) {
              exigenciasInvalidas = this.resetarCumprimentoExigenciasInvalidas(exigencia); 
              requerimento = this.resetarCumprimentoExigencias(resultadoExigencia.exigencia);
            }
          });
          this.setState({
            requerimento: { ...requerimento },
            exigenciasInvalidas,
          });
          // se a lista estiver vazia, não cumpriu exigência alguma.
        } else if (lista.length > 0) {
          let { requerimento } = { ...this.state };
          let { exigenciasInvalidas } = { ...this.state };
          lista.forEach((exigencia) => {
            const resultadoExigencia = this.verificarSeExigenciaFoiCumpridaAnteriormente(exigencia);
            if (resultadoExigencia.deveResetar) {
              exigenciasInvalidas = this.resetarCumprimentoExigenciasInvalidas(exigencia);
              requerimento = this.resetarCumprimentoExigencias(resultadoExigencia.exigencia);
            }
          });
          this.setState({
            requerimento: { ...requerimento },
            exigenciasInvalidas,
          });
        }
        this.confirmSendData();
      } else if (this.state.acao === 'indeferidos') {
        const { requerimento } = { ...this.state };
        const { concomitanciaDePeriodosNoRequerimento } = { ...this.state };
        requerimento.estado = 3;
        let mensagemConfirmacao = msgsConfirmacaoIndeferimento.reaberturaIndeferimento;
        // exibir o modal de confirmação somente se o requerimento nao possuir periodos concomitantes
        if (!concomitanciaDePeriodosNoRequerimento) {
          this.setState({
            requerimento: { ...requerimento },
            alertas: [mensagemConfirmacao],
            showModalAlerta: !this.state.showModalAlerta,
          });
        } else {
          // alterar o requerimento após clicar no botao "SIM" do modal de concomitancia (modalAlertaRequerPerConcomitancia)
          this.setState({ concomitanciaDePeriodosNoRequerimento: false });
          this.confirmSendData();
        }
      } else if (this.state.acao === 'complementar-aposentadoria') {
        const { requerimento } = { ...this.state };
        requerimento.estado = 3;
        this.setState({
          requerimento: { ...requerimento },
        })
        this.confirmSendData();
      } else {
        this.confirmSendData();
      }
    }
  }

  handleSaveButtonConfirmarIndeferimento = () => {
    const { requerimento } = { ...this.state };
    requerimento.estado = ESTADO_INDEFERIDO_RATIFICADO;
    let mensagemConfirmacao = '';
    mensagemConfirmacao = msgsConfirmacaoIndeferimento.indeferimento;
    this.setState({
      requerimento: { ...requerimento },
      alertas: [mensagemConfirmacao],
      showModalAlerta: !this.state.showModalAlerta,
    });
  }

  validarCamposSegregacao = (nome) => {
    const { requerimento } = { ...this.state };
    if (requerimento[nome] && requerimento[nome] !== null && requerimento[nome] !== '') {
      requerimento[nome] = Number(requerimento[nome]);
    } else if (requerimento[nome] === '') {
      requerimento[nome] = null;
    }
    this.setState({
      requerimento: { ...requerimento },
    })
  }

  validarCtcEspecifica = () => {
    const { requerimento, acao, exibirUploadArquivosNaConsulta } = { ...this.state };
    let existeDocCtc = false;

    if (requerimento.estado !== ESTADO_INDEFERIDO_RATIFICADO) {
      if (requerimento.ctcEspecifica === 1) {
        if (acao === 'novo' || acao === 'criado' || exibirUploadArquivosNaConsulta) {
          const arquivos = requerimento.arquivos;
          if (arquivos.length > 0) {
            for (let i = 0, docs = arquivos.length; i < docs; i += 1) {
              existeDocCtc = arquivos[i].tipoDocumento === 1;
              if (existeDocCtc) {
                return true;
              }
            }
          }
        } else if (acao === 'indeferidos' || acao === 'cumprir-exigencia') {
          const docProbIndeferido = requerimento.documentosProbatorios;
          const arqIndeferido = requerimento.arquivos;

          if (docProbIndeferido.length > 0) {
            for (let j = 0, docs = docProbIndeferido.length; j < docs; j += 1) {
              existeDocCtc = docProbIndeferido[j].tipoDocumento === 1;
              if (existeDocCtc) {
                return true;
              }
            }
          }
          if (arqIndeferido.length > 0) {
            for (let k = 0, docs = arqIndeferido.length; k < docs; k += 1) {
              existeDocCtc = arqIndeferido[k].tipoDocumento === 1;
              if (existeDocCtc) {
                return true;
              }
            }
          }
        } else {
          const docProbatorio = requerimento.documentosProbatorios;
          if (docProbatorio.length > 0) {
            for (let n = 0, doc = docProbatorio.length; n < doc; n += 1) {
              existeDocCtc = docProbatorio[n].tipoDocumento === 1;
              if (existeDocCtc) {
                return true;
              }
            }
          }
        }
        return false;
      }
    }
    return true;
  }

  calcularTempoDeContribuicaoLiquido = (periodo) => {
    if (periodo) {
      const qtdDiasDesconto = periodo.qtdDiasDesconto ? Number(periodo.qtdDiasDesconto) : 0;
      const tempoBruto = periodo.qtdDiasContribuicaoBruto ? Number(periodo.qtdDiasContribuicaoBruto) : 0;
      const retorno = Math.trunc((tempoBruto - qtdDiasDesconto));
      return retorno;
    }
    return 0;
  }

  calcularTempoTotalAmdRgps = (lista, listaIndexada) => {
    let resultadoDia = 0;
    let resultadoMes = 0;
    let resultadoAno = 0;

    let resultadoQtdMeses = 0;
    let restoDivisaoDia = 0;
    let resultadoQtdAnos = 0;
    let restoDivisaoMes = 0;
    let totalDiasDescontados = 0;

    const acrescentarMesDias = 30;
    const qtdDiasMes = 30;
    const qtdMesesAno = 12;
    const acrescentarAnoDias = 365

    lista.forEach((periodo) => {
      if (periodo.totalDia !== '' && periodo.totalMes !== '' && periodo.totalAno !== '') {

        resultadoDia += periodo.totalDia;
        resultadoQtdMeses = Math.trunc(resultadoDia / qtdDiasMes);
        restoDivisaoDia = (resultadoDia % qtdDiasMes);
        resultadoDia = restoDivisaoDia;

        resultadoMes += periodo.totalMes + resultadoQtdMeses;
        resultadoQtdAnos = Math.trunc(resultadoMes / qtdMesesAno);
        restoDivisaoMes = (resultadoMes % qtdMesesAno);
        resultadoMes = restoDivisaoMes;

        resultadoAno += periodo.totalAno + resultadoQtdAnos;
      }
    });

    listaIndexada.forEach((item) => {
      if (item.qtdDiasDesconto > 0) {
        totalDiasDescontados += item.qtdDiasDesconto;
      }
    });

    return Number(((resultadoAno * acrescentarAnoDias) + (resultadoMes * acrescentarMesDias) + resultadoDia) - totalDiasDescontados);

  }

  isRelacaoRgpsRpps = (destinatario) => {
    const { solicitante } = { ...this.state.requerimento };
    let retorno = false;

    if ((destinatario && destinatario === '01000') || (destinatario && destinatario.codigo === '01000') ||
      (User.logged().isRGPS()) ||
      (solicitante && solicitante.codigo === '01000')) {
      retorno = true;
    }
    return retorno;
  }

  calcularTempoRO = (destinatario, alteracaoManual) => {
    const { requerimento } = { ...this.state };
    let lista = [];
    let somatorioTempoContribuicao = 0;
    let periodoAux = {};
    let listaAux = [];
    let retorno = false;

    if ((this.state.acao !== 'realizar-analise' && this.state.acao !== 'emitir-parecer-medico') && requerimento.estado !== ESTADO_INDEFERIDO_RATIFICADO) {
      if (requerimento.requerimentoPeriodos) {
        lista = requerimento.requerimentoPeriodos;
      }

      const listaIndexada = lista.map((item, i) => {
        const itemIndexado = item;
        itemIndexado.indice = i;
        itemIndexado.qtdDiasContribuicaoBruto = this.isRelacaoRgpsRpps(destinatario) ? this.calcularPeriodoRgps(itemIndexado, false) : this.calcularPeriodoRpps(itemIndexado);
        itemIndexado.qtdDiasContribuicaoLiquido = this.calcularTempoDeContribuicaoLiquido(itemIndexado);
        itemIndexado.qtdDiasDesconto = itemIndexado.qtdDiasDesconto ? itemIndexado.qtdDiasDesconto : 0;
        return itemIndexado;
      });

      if (listaIndexada.length > 0) {
        if (this.isRelacaoRgpsRpps(destinatario)) {
          listaIndexada.forEach((periodo) => {
            periodoAux = this.calcularPeriodoRgps(periodo, true);
            listaAux.push(periodoAux);
          });
          somatorioTempoContribuicao = this.calcularTempoTotalAmdRgps(listaAux, listaIndexada);
        } else {
          listaIndexada.forEach((periodo) => {
            if (periodo.qtdDiasContribuicaoLiquido) {
              somatorioTempoContribuicao += periodo.qtdDiasContribuicaoLiquido;
            }
          });
        }
        if (!alteracaoManual) {
          requerimento.destinatario = destinatario;
          requerimento.tempoContribuicaoRegimeOrigemDias = somatorioTempoContribuicao;

          this.setState({
            requerimento: { ...requerimento },
          })
        } else { // Verifica se o tempo RO informado manualmente é maior que o calculado pelo sistema
          retorno = true;
          if (requerimento.alteracaoTempoRO === 1 && requerimento.tempoContribuicaoRegimeOrigemDias > somatorioTempoContribuicao) {
            retorno = false;
          }
          return retorno;
        }
      }
    } else {
      retorno = true;
      return retorno;
    }
  };

  recalcularTempoRO = () => {
    const { requerimento } = { ...this.state };
    const { destinatario } = { ...this.state.requerimento }
    let { historyTempoRO } = { ...this.state };
    let lista = [];
    let somatorioTempoContribuicao = 0;
    let periodoAux = {};
    let listaAux = [];
    let checkboxMarcado = 0;

    if (requerimento.requerimentoPeriodos) {
      lista = requerimento.requerimentoPeriodos;
    }

    const listaIndexada = lista.map((item, i) => {
      const itemIndexado = item;
      itemIndexado.indice = i;
      itemIndexado.qtdDiasContribuicaoBruto = this.isRelacaoRgpsRpps(destinatario) ? this.calcularPeriodoRgps(itemIndexado, false) : this.calcularPeriodoRpps(itemIndexado);
      itemIndexado.qtdDiasContribuicaoLiquido = this.calcularTempoDeContribuicaoLiquido(itemIndexado);
      itemIndexado.qtdDiasDesconto = itemIndexado.qtdDiasDesconto ? itemIndexado.qtdDiasDesconto : 0;
      return itemIndexado;
    });

    if (listaIndexada.length > 0) {
      if (this.isRelacaoRgpsRpps(destinatario)) {
        listaIndexada.forEach((periodo) => {
          periodoAux = this.calcularPeriodoRgps(periodo, true);
          listaAux.push(periodoAux);
        });
        somatorioTempoContribuicao = this.calcularTempoTotalAmdRgps(listaAux, listaIndexada);
      } else {
        listaIndexada.forEach((periodo) => {
          if (periodo.qtdDiasContribuicaoLiquido) {
            somatorioTempoContribuicao += periodo.qtdDiasContribuicaoLiquido;
          }
        });
      }

      requerimento.destinatario = destinatario;
      requerimento.tempoContribuicaoRegimeOrigemDias = somatorioTempoContribuicao;
      historyTempoRO = somatorioTempoContribuicao;
      const changeObj = {
        value: somatorioTempoContribuicao,
        isValid: true,
      };

      this.setState({
        requerimento: { ...requerimento },
        historyTempoRO: historyTempoRO,
        showModalRecalcularTempoRO: !this.state.showModalRecalcularTempoRO,
        checkTempoRo: checkboxMarcado,
      }), this.handleChange(changeObj, 'tempoContribuicaoRegimeOrigemDias');
    } else { // no caso do requerimento não possuir períodos cadastrados
      this.setState({
        requerimento: {
          ...requerimento,
          tempoContribuicaoRegimeOrigemDias: historyTempoRO,
        },
        showModalRecalcularTempoRO: !this.state.showModalRecalcularTempoRO,
        checkTempoRo: checkboxMarcado,
      })
    }
  };


  atualizarTempoRO = (tempoRO) => {
    const { requerimento } = { ...this.state };
    const historyTempoRO = tempoRO;
    requerimento.tempoContribuicaoRegimeOrigemDias = historyTempoRO;
    this.setState({
      requerimento: { ...requerimento },
    })
  }

  /**
   * Trata envio dos dados
   */
  confirmSendData = () => {
    const touched = true;
    let url = 'requerimentos-compensacao-aposentadoria';
    if (this.state.acao !== 'novo') {
      if (this.state.acao === 'qualificar') {
        url = `requerimentos-compensacao-aposentadoria/qualificar/${this.state.requerimento.protocolo}`;
      } else if (this.state.acao === 'salvarERejeitar') {
        url = 'requerimentos-compensacao-aposentadoria/solicitar-e-rejeitar';
      } else {
        url = `requerimentos-compensacao-aposentadoria/${this.state.requerimento.protocolo}`;
      }
    }

    const { requerimento } = { ...this.state };
    // Alteração para transformar o valor do campo rendaMensalInicial
    // para numero antes de persistir na tabela.
    if (typeof (this.state.requerimento.rendaMensalInicial) !== 'number') {
      let renda = this.state.requerimento.rendaMensalInicial;
      renda = renda.replace(/\./g, '').replace(/,/g, '.');
      // const { requerimento } = { ...this.state };
      requerimento.rendaMensalInicial = Number(renda);
      this.setState({
        requerimento: { ...requerimento },
      })
    }

    this.validarCamposSegregacao('tipoSegregacaoSolicitante');
    this.validarCamposSegregacao('tipoSegregacaoDestinatario');

    // Vinicius
    const { validadeCampos } = { ...this.state };
    Object.keys(validadeCampos).forEach((key) => {
      validadeCampos[key] = true;
    });
    let codigoDestinatario = '';
    if (requerimento.destinatario) {
      codigoDestinatario = requerimento.destinatario;
    }
    if (requerimento.destinatario.codigo) {
      codigoDestinatario = requerimento.destinatario.codigo;
    }

    if (codigoDestinatario) {
      let orgaoCentralizador = null;
      let orgao = this.props.destinatarios.find(item => item.value === codigoDestinatario);
      if (orgao) {
        if (orgao.codigoOrgaoCentralizador && orgao.inOrgaoUniao) {
          orgaoCentralizador = this.props.destinatarios.find(item => item.value === orgao.codigoOrgaoCentralizador);
          // Se o destinatario escolhido for um orgao centralizado, abrir o requerimento para o
          // orgão centralizador
          // inserir o valor do orgao centralizador no destinatario e o orgao origem será
          // o orgão centralizado
          if (orgaoCentralizador !== null) {
            if (this.state.acao === 'novo') {
              requerimento.destinatarioOrigem = codigoDestinatario;
              requerimento.destinatario = orgaoCentralizador.value;
            }
            if (this.state.acao === 'cumprir-exigencia' || this.state.acao === 'indeferidos') {
              requerimento.destinatario = { codigo: orgaoCentralizador.value };
              requerimento.destinatarioOrigem = { codigo: codigoDestinatario };
            }
            this.setState({
              requerimento: { ...requerimento },
            })
          }
        }
        else {
          if (this.state.acao === 'cumprir-exigencia' || this.state.acao === 'indeferidos') {
            requerimento.destinatario = { codigo: codigoDestinatario };

            if (this.state.acao === 'indeferidos') {
              const { checkExigirQualificacao } = { ...this.state };
              //if (checkExigirQualificacao) {
              requerimento.exigirQualificacao = checkExigirQualificacao;
              //}
            }
          }
          this.setState({
            requerimento: { ...requerimento },
          })
        }
      }
    }

    this.setState({
      touched,
      validadeCampos,
      requestPesquisa: null,
    }, () => this.handleSave(url));
  }

  houveAlteracaoCamposRequerimento = () => {
    let houveAlteracao = false;
    let lista = this.verificaAlteracaoCamposEstadoExigencia();
    let existeAlteracaoNosOutrosCampos = false;

    if (lista && lista.length === 0) {
      // verificar campos alterados que nao sao exigencia
      lista = this.verificaAlteracaoCamposQueNaoSaoExigencia();
    }

    if (lista && lista.length > 0) {
      const indexNaoArquivo = lista.findIndex(i => (i !== 'arquivos'));
      // campos alterados que nao sao upload avulso
      if (indexNaoArquivo !== -1) {
        existeAlteracaoNosOutrosCampos = true;
      }
    }

    houveAlteracao = existeAlteracaoNosOutrosCampos;
    return houveAlteracao;
  }

  atualizarConflitosPeriodos = (novaLista) => {
    this.setState(prevState => ({
        requerimento: {
          ...prevState.requerimento,
          listaConflitosPeriodos: novaLista
        }
      }));
  };

  /**
   * Trata as acoes dos botoes principais "Criar Requerimento", "Emitir Parecer" etc..
   */
  handleSave = (url) => {
    let { requerimento, clicouBotaoPesquisarCtc } = { ...this.state };
    let { listaConflitosPeriodos } = { ...this.state.requerimento };
    if (this.formularioProntoParaEnvio() || requerimento.estado === ESTADO_INDEFERIDO_RATIFICADO) {
      if (this.calcularTempoRO(requerimento.destinatario, true)) {
        if (this.validarCtcEspecifica()) {
          if (requerimento.estado === 2) {
            let { exigenciasInvalidas } = { ...this.state };
            const { exigencias } = { ...this.state.requerimento };
            exigencias.forEach((exigencia) => {
              const resultadoExigencia  = this.verificarSeExigenciaFoiCumpridaAnteriormente(exigencia);
              if (resultadoExigencia.deveResetar) {
                exigenciasInvalidas = this.resetarCumprimentoExigenciasInvalidas(exigencia);
                requerimento = this.resetarCumprimentoExigencias(resultadoExigencia.exigencia);
              }
            });
            if (requerimento.arquivos && requerimento.arquivos.length > 0) {
              this.uploadFileAvulso();
            }
            this.setState({
              requerimento: { ...requerimento },
              exigenciasInvalidas,
            });
          }
          let options;
          const requerimentoAtualizado = {
             ...requerimento,
             listaConflitosPeriodos
           };
          if (this.state.chaveConfirmacao) {
            options = { 'Chave-Confirmacao': this.state.chaveConfirmacao };
          }
          if (this.state.acao === 'novo' || this.state.acao === 'salvarERejeitar') {
            doPost(
              url,
              requerimentoAtualizado,
              this.trataSucessoResponseEnvio,
              this.trataErrosResponse,
              options,
            );
          } else {
            if (this.state.acao !== 'cumprir-exigencia' || (this.state.acao === 'cumprir-exigencia' && this.houveAlteracaoCamposRequerimento())) {
              doPut(
                url,
                requerimentoAtualizado,
                this.trataSucessoResponseEnvio,
                this.trataErrosResponse,
                {
                  codigo: 3009,
                  mensagem: 'Esta solicitação já foi atendida por outro usuário.',
                },
                options,
              );
            }
          }
        } else {
          trataMensagensErro(['Documento de CTC não encontrado. Obrigatório anexar a CTC específica em requerimento com indicador de existência de CTC específica informado']);
        }
      } else {
        trataMensagensErro(['Tempo de contribuição de regime de origem inválido. Tempo de Regime de Origem informado manualmente deve ser menor ou igual ao calculado pelo sistema.']);
      }

    } else if (clicouBotaoPesquisarCtc) {
      this.setState({ clicouBotaoPesquisarCtc: false });
      trataMensagensErro(['Alteração não permitida. Não foram identificadas modificações nos períodos do requerimento']);
    } else {
      trataMensagensErro(['Informe corretamente os atributos indicados na tela.']);
    }
  }

  handleDocumentSent = () => {
    this.setState({ sucessoUpload: true });
  }

  handleFailDocumentSent = () => {
  }

  uploadFile = (response) => {
    const { requerimento } = { ...this.state };
    if (this.state.acao === 'novo') {
      requerimento.protocolo = response.headers.location.substring(
        response.headers.location.lastIndexOf('/') + 1,
        response.headers.location.length,
      );
    }
    const url = 'documentos';
    const documentos = requerimento.arquivos;
    if (documentos.length > 0) {
      for (let i = 0, docs = documentos.length; i < docs; i += 1) {
        const body = {
          protocolo: requerimento.protocolo,
          tipoDocumento: documentos[i].tipoDocumento,
          documento: documentos[i].documento,
        };
        doMultipartFormPost(
          url,
          body,
          this.handleDocumentSent,
          this.handleFailDocumentSent,
        );
      }
    }
  }

  isUploadAvulsoNaTelaDeExigencia = (requerimento) => {
    let retorno = false;
    if ((requerimento.exigencias && requerimento.exigencias.length > 0) && (requerimento.arquivos && requerimento.arquivos.length > 0)) {
      const listaExigenciasCumpridas = requerimento.exigencias.filter(exigencia => (exigencia.atendida === 1));
      if (listaExigenciasCumpridas.length > 0) {
        listaExigenciasCumpridas.forEach((exig) => {
          const index = requerimento.arquivos.findIndex(arq => (arq.tipoDocumento === exig.tipoDocumento));
          if (index !== -1) {
            retorno = true;
          }
        });
      }
    }
    return retorno;
  }

  trataSucessoUploadAvulsoExigencias = () => {
    const { requerimento } = { ...this.state };
    this.setState({ sucessoUpload: true });
    let mensagemSucesso = '';
    const consultaExigencia = this.isConsultaExigencia();
    const uploadNoDetalhamentoEmExigencia = this.isUploadAvulsoNaTelaDeExigencia(requerimento);
    if (this.state.sucessoUpload) {
      if (consultaExigencia) {
        mensagemSucesso = 'Documento(s) anexado(s) ao requerimento com sucesso.';
      } else if (uploadNoDetalhamentoEmExigencia) {
        mensagemSucesso = 'Documento(s) anexado(s) ao requerimento com sucesso. Exigência(s) encerrada(s).';
      } else {
        mensagemSucesso = 'Documento(s) anexado(s) ao requerimento com sucesso.';
      }
      requerimento.arquivos = [];
      this.setState({
        habilitarBotaoCarregarDocumento: false,
        requerimento,
      }, this.atualizarDocumentosProbatorios);
      trataMensagemSucesso([mensagemSucesso]);
    }
  }

  trataSucessoUploadAvulso = () => {
    const { requerimento } = { ...this.state };
    this.setState({ sucessoUpload: true });
    const mensagemSucesso = ['Documento(s) anexado(s) ao requerimento com sucesso.'];
    if (this.state.sucessoUpload) {
      requerimento.arquivos = [];
      this.setState({
        habilitarBotaoCarregarDocumento: false,
        requerimento,
      }, this.atualizarDocumentosProbatorios);
      trataMensagemSucesso(mensagemSucesso);
    }
  }

  handleFailUploadAvulso = () => {
    const mensagemErro = ['Falha ao anexar documento(s) ao requerimento.'];
    trataMensagensErro(mensagemErro);
  }

  trataSucessoResponseDocs = (response) => {
    const { requerimento } = { ...this.state };
    const listaDocs = response.data;
    this.setState({
      requerimento: {
        ...requerimento,
        documentosProbatorios: listaDocs,
      },
    });
  }

  uploadFileAvulso = () => {
    const { requerimento } = { ...this.state };
    const url = 'documentos';
    if (requerimento.estado === 2) {
      const documentos = requerimento.arquivos;
      if (documentos.length > 0) {
        documentos.forEach((documento) => {
          const body = {
            protocolo: requerimento.protocolo,
            documento: documento.documento,
            tipoDocumento: documento.tipoDocumento,
          };
          doMultipartFormPostExigencias(
            url,
            body,
            this.trataSucessoUploadAvulsoExigencias,
            this.handleFailUploadAvulso,
          );
        });
      }
    } else {
      // const url = 'documentos';
      const documentos = requerimento.arquivos;
      if (documentos.length > 0) {
        for (let i = 0, docs = documentos.length; i < docs; i += 1) {
          const body = {
            protocolo: requerimento.protocolo,
            tipoDocumento: documentos[i].tipoDocumento,
            documento: documentos[i].documento,
          };
          doMultipartFormPost(
            url,
            body,
            this.trataSucessoUploadAvulso,
            this.handleFailUploadAvulso,
          );
        }
      }
    }
  }

  atualizarDocumentosProbatorios = async () => {
    // if(this.state.acao !== 'indeferidos') {
    //   await this.sleep(3000);
    // } else {
    await this.sleep(1000);
    // }
    doGet(
      `/requerimentos-compensacao-aposentadoria/documentos-probatorios/${this.state.requerimento.protocolo}`,
      this.trataSucessoResponseDocs,
      this.trataErrosResponse,
    );
  }

  sleep = (time) => {
    return new Promise((resolve) => setTimeout(resolve, time));
  }

  verificarSucessoUpload = () => {
    if (this.state.sucessoUpload) {
      const mensagemSucesso = ['Documentos anexados ao requerimento com sucesso.'];
      trataMensagemSucesso(mensagemSucesso);
    }
  }

  /**
   * Trata as respostas positivas em caso de submissao de formulario (POST, PUT)
   */
  trataSucessoResponseEnvio = (response) => {
    if (['novo', 'indeferidos', 'realizar-analise'].includes(this.state.acao)) {
      this.uploadFile(response);
      this.verificarSucessoUpload();
    }
    if (this.state.acao === 'cumprir-exigencia') {
      this.setState(this.buscaRequerimentoAposAlteracaoPeriodo);
    }
    if ((this.state.chaveConfirmacao || response.data === '') && (response.status === 201 || response.status === 200)) {
      this.setState({
        chaveConfirmacao: null,
        alertas: [],
        showModalAlertaRequerPerConcomitancia: false,
        showModalAlerta: false,
      });
    }
    this.trataSucesso();
  }

  /**
   * Trata as respostas positivas em caso de submissao de formulario (POST, PUT)
   */
  handleFechamentoModalAlerta = () => {
    this.setState({
      chaveConfirmacao: null,
      alertas: [],
      showModalAlerta: !this.state.showModalAlerta,
    });
  }

  handleFechamentoModalAlertaRequerimentosPeriodos = () => {
    this.setState({
      chaveConfirmacao: null,
      alertas: [],
      showModalAlertaRequerimentosPeriodos: !this.state.showModalAlertaRequerimentosPeriodos,
    });
  }

  handleFechamentoModalAlertaRequerPerConcomitancia = () => {
    this.setState({
      chaveConfirmacao: null,
      alertas: [],
      showModalAlertaRequerPerConcomitancia: !this.state.showModalAlertaRequerPerConcomitancia,
    });
  }

  handleFechamentoModalCtcNaoEncontrada = () => {
    this.setState({
      chaveConfirmacao: null,
      alertas: [],
      showModalAlertaCtcNaoEncontrada: !this.state.showModalAlertaCtcNaoEncontrada,
    });
  }

  handleFechamentoModalAlertaReqAprovadoSemData = () => {
    this.setState({
      chaveConfirmacao: null,
      alertas: [],
      showModalAlertaReqAprovadoSemDataIngresso: !this.state.showModalAlertaReqAprovadoSemDataIngresso,
    });
  }

  handleModalRecalcularTempoRO = () => {
    const { requerimento, historyCheckTempoRO } = { ...this.state }
    let checkTempoRo = historyCheckTempoRO;

    this.setState({
      chaveConfirmacao: null,
      alertas: [],
      showModalRecalcularTempoRO: !this.state.showModalRecalcularTempoRO,
      requerimento: {
        ...requerimento,
        alteracaoTempoRO: checkTempoRo,
      },
      historyCheckTempoRO: historyCheckTempoRO,
    });
  }

  trataSucesso = () => {
    let mensagemSucesso = 'Requerimento aberto.';
    let cumpriuExigencia = false;
    switch (this.state.acao) {
      case 'novo': {
        this.setState({
          estadoFormulario: 'criado',
        });
        break;
      }
      case 'qualificar': {
        mensagemSucesso = 'Requerimento qualificado com sucesso.';
        this.props.history.goBack();
        break;
      }
      case 'cumprir-exigencia':
        mensagemSucesso = 'Requerimento atualizado.';
        let houveAlteracao = this.verificaAlteracaoCamposEstadoExigencia().length > 0;
        this.state.requerimento.exigencias.forEach((exigencia) => {
          if (exigencia.atendida) {
            cumpriuExigencia = true;
          }
        });
        if (houveAlteracao && cumpriuExigencia) {
          mensagemSucesso = 'Requerimento atualizado e exigência encerrada.';
        } else if (houveAlteracao && !cumpriuExigencia) {
          mensagemSucesso = 'Requerimento atualizado.';
        }
        // mensagemSucesso = 'Requerimento atualizado e exigência encerrada.';
        this.buscaRequerimento(this.handleSuccessBuscaRequerimentoAtualizacao);
        break;
      case 'realizar-analise':
        mensagemSucesso = 'Requerimento analisado.';
        this.props.history.goBack();
        break;
      case 'emitir-parecer-medico':
        mensagemSucesso = 'Requerimento atualizado com o parecer do médico.';
        this.props.history.goBack();
        break;
      case 'indeferidos': {
        mensagemSucesso = 'Requerimento atualizado com sucesso.';
        this.props.history.goBack();
        break;
      }
      case 'salvarERejeitar': {
        mensagemSucesso = 'Requerimento criado no estado rejeitado.';
        this.handleModalRejeicaoRequerimento();
        this.setState({
          acao: 'novo',
          estadoFormulario: 'criado',
        });
        break;
      }
      case 'complementar-aposentadoria': {
        mensagemSucesso = 'Requerimento complementado com sucesso.';
        this.props.history.goBack();
        break;
      }
      default: mensagemSucesso = 'Requerimento atualizado e exigência encerrada.';
    }
    trataMensagemSucesso([mensagemSucesso]);
  }

  trataSucessoRejeitar = () => {
    trataMensagemSucesso(['Requerimento rejeitado.']);
    this.props.history.goBack();
  }

  /**
   * Trata os erros nas requisicoes (busca e submissao de formulario)
   */
  trataErrosResponse = (error) => {
    const { validadeCampos } = { ...this.state };
    const { requerimento } = { ...this.state };
    if (error && error.data && error.data.tipo === 2) {
      const { data } = { ...error };
      if (error.data.alertas[0].codigo === 4513) {
        this.setState({
          chaveConfirmacao: data.chaveConfirmacao,
          alertas: data.alertas,
          showModalAlerta: false,
          showModalAlertaRequerPerConcomitancia: !this.state.showModalAlertaRequerPerConcomitancia,
          concomitanciaDePeriodosNoRequerimento: true,
        });
      } else {
        this.setState({
          chaveConfirmacao: data.chaveConfirmacao,
          alertas: data.alertas,
          showModalAlerta: !this.state.showModalAlerta,
        },);
      }
    } else {
      if (this.state.requestPesquisa && !this.state.acao === 'qualificar') {
        camposPreenchidosPorServico[this.state.requestPesquisa].forEach((key) => {
          validadeCampos[key] = false;
          requerimento[key] = '';
        });
        this.setState({
          requerimento: { ...this.state.requerimento, requerimento },
          validadeCampos,
        });
      } else if (this.state.requestPesquisa && this.state.acao === 'qualificar') {
        validadeCampos.cpf = false;
        this.setState({
          requerimento: { ...this.state.requerimento, requerimento },
          validadeCampos,
        });
      }
      if (error) {
        const { data } = { ...error };
        if (error.status === 400) {
          if (data.erros && data.erros.length >= 1) {
            data.erros.forEach((erro) => {
              if (erro.atributo in validadeCampos) {
                validadeCampos[[erro.atributo]] = false;
              }
            });
            // if (this.state.acao === 'cumprir-exigencia'
            // && requerimento.estado === 2 && requerimento.exigencias) {
            //   const exigenciaComAtributo = requerimento.exigencias.filter(item => item.atributo);
            //   exigenciaComAtributo.forEach((exigencia) => {
            //     if (!['dataIngresso', 'dataDesvinculacao'].includes(exigencia.atributo)) {
            //       validadeCampos[exigencia.atributo] = false;
            //     }
            //   });
            // }
            this.setState({ ...this.state, validadeCampos, estadoFormulario: 'erro-regra' });
          }
          const { acao } = { ...this.state };
          if (acao === 'cumprir-exigencia' && requerimento.estado === 2 && requerimento.exigencias) {
            const exigenciaComAtributo =
              requerimento.exigencias.filter(item => item.atributo);
            exigenciaComAtributo.forEach((exigencia) => {
              if (!['dataIngresso', 'dataDesvinculacao'].includes(exigencia.atributo)) {
                validadeCampos[exigencia.atributo] = false;
              }
            });
          }
          this.setState({ ...this.state, validadeCampos, estadoFormulario: 'erro-regra' });
          const { validadeBotoesIndeferidos } = { ...this.state };
          if (this.state.requestPesquisa === 'centralService' && validadeBotoesIndeferidos.pesquisarDadosBeneficio === true) {
            validadeBotoesIndeferidos.pesquisarDadosBeneficio = false;
            this.setState({ validadeBotoesIndeferidos });
          }
          if (this.state.requestPesquisa === 'cnis' && validadeBotoesIndeferidos.pesquisarDadosPessoais === true) {
            validadeBotoesIndeferidos.pesquisarDadosPessoais = false;
            this.setState({ validadeBotoesIndeferidos });
          }
          if (acao === 'indeferidos' && this.state.showModalAlerta) {
            this.setState({ showModalAlerta: false });
          }
          this.setState({ ...this.state, validadeCampos, estadoFormulario: 'erro-regra' });
        } else if (error.status === 404) {
          if (this.state.requestPesquisa && this.state.requestPesquisa === 'periodosCtc') {
            const { data } = { ...error };
            this.setState({
              chaveConfirmacao: data.chaveConfirmacao,
              alertas: [],
              showModalAlertaCtcNaoEncontrada: !this.state.showModalAlertaCtcNaoEncontrada,
            });
          }
        }
      }
    }
  }

  /**
   * Funcao executada quando botao "Novo Requerimento" é clicado
   */
  handleNewButton = () => {
    if (this.props.auth.checkPermission(['requerer-compensacao-rpps'])) {
      this.setState(this.buscaParticipantePeloCnpjLogado());
    }
    this.setState(
      { ...this.getInitialState(), reset: true },
      () => this.setState({ reset: false }, () => window.scrollTo(0, 0)),
    );
    this.controlarExibicaoMultiplosPeriodos();
  }

  formularioRequerimento = () => (
    <DadosRequerimentoAposentadoria
      acao={this.state.acao}
      alteraEstadoRequerimento={this.alteraEstadoRequerimento}
      auth={this.props.auth}
      camposCnis={camposPreenchidosPorServico.cnis}
      camposCentralService={camposPreenchidosPorServico.centralService}
      estadoFormulario={this.state}
      handleChange={this.handleChange}
      handleKeyUp={this.handleKeyUp}
      handleSearchButton={this.handleSearchButton}
      handlePesquisaBotaoEloNit={this.handlePesquisaBotaoEloNit}
      handleModalCadeiaDeNitModal={this.handleModalCadeiaDeNitModal}
      handleModalAlteraDataCessacao={this.handleModalAlteraDataCessacao}
      handleModalAlteraMotivoCessacao={this.handleModalAlteraMotivoCessacao}
      handleModalAlteraDataEMotivoCessacao={this.handleModalAlteraDataEMotivoCessacao}
      handleModalAlteraSegregacaoMassa={this.handleModalAlteraSegregacaoMassa}
      handleSearchNBButton={this.handleSearchNBButton}
      match={this.props.match}
      tiposDocumentos={this.props.tiposDocumentos}
      arquivos={this.props.arquivos}
      apagaRegraDeCalculo={this.apagaRegraDeCalculo}
      vinculosConcomitantesConfirmado={this.state.vinculosConcomitantesConfirmado}
      possuiVinculosConcomitantes={this.state.possuiVinculosConcomitantes}
      clickVinculosTab={this.clickVinculosTab}
      exibirUploadArquivosNaConsulta={this.state.exibirUploadArquivosNaConsulta}
      exibirModalCadeiaDeNit={this.state.exibirModalCadeiaDeNit}
      exibirModalDataCessacao={this.state.exibirModalDataCessacao}
      exibirModalMotivoCessacao={this.state.exibirModalMotivoCessacao}
      exibirModalDataEMotivoCessacao={this.state.exibirModalDataEMotivoCessacao}
      exibirModalSegregacaoMassa={this.state.exibirModalSegregacaoMassa}
      listaExigencias={this.state.exigenciasOriginais}
      atualizarDocumentosProbatorios={this.atualizarDocumentosProbatorios}
      temBloqueioAtivoContratoDtp={this.props.temBloqueioAtivoContratoDtp}
      atualizarDataCessacao={this.atualizarDataCessacao}
      atualizarMotivoCessacao={this.atualizarMotivoCessacao}
      atualizarHistoricoAuditorias={this.atualizarHistoricoAuditorias}
      atualizarTipoSegregacaoMassaDestinatario={this.atualizarTipoSegregacaoMassaDestinatario}
      atualizarTipoSegregacaoMassaSolicitante={this.atualizarTipoSegregacaoMassaSolicitante}
      handleChangeExigirQualificacao={this.handleChangeExigirQualificacao}
      handleChangeTempoROManual={this.handleChangeTempoROManual}
      handleChangeCtcEspecifica={this.handleChangeCtcEspecifica}
      handleChangeProtocoloNaoConstaOuIlegivel={this.handleChangeProtocoloNaoConstaOuIlegivel}
      handleSearchPeriodos={this.handleSearchPeriodos}
      atualizarDataIngressoDesvinculacaoETempo={this.atualizarDataIngressoDesvinculacaoETempo}
      determinarConcomitancias={this.determinarConcomitancias}
      ordenarListaPeriodos={this.ordenarListaPeriodos}
      verificarHabilitacaoDataIngressoDesvinculacaoETempo={this.verificarHabilitacaoDataIngressoDesvinculacaoETempo}
      verificarHabilitacaoDataHomologacaoTc={this.verificarHabilitacaoDataIngressoDesvinculacaoETempo}
      calcularPeriodoRgps={this.calcularPeriodoRgps}
      calcularPeriodoRpps={this.calcularPeriodoRpps}
      calcularTempoRO={this.calcularTempoRO}
      atualizarTempoRO={this.atualizarTempoRO}
      handleModalTempoRO={this.handleModalRecalcularTempoRO}
      validacaoDeVinculosConcomitantes={this.validacaoDeVinculosConcomitantes}
      atualizarVinculosConcomitantesConfirmado={this.atualizarVinculosConcomitantesConfirmado} 
      handleChangeFile={this.handleChangeFile}
      handleChangeTipoDocumento={this.handleChangeTipoDocumento}
      isDataCessacaoManualPreenchida={this.isDataCessacaoManualPreenchida}
    />
  );

  montaCorpoRequerimento = () => {
    const todasTabs = this.montaTabs();
    // console.log('tabPaginaAtual:', this.state.tabPaginaAtual, 'totalTabs:', todasTabs.length, 'tabs:', todasTabs.map(t => t.props.title));
    const maxTabs = 4;
    const temPaginacao = todasTabs.length > maxTabs;
    const inicio = this.state.tabPaginaAtual * maxTabs;
    const fim = inicio + maxTabs;

    let tabsExibidas = todasTabs;
    if (temPaginacao) {
      tabsExibidas = todasTabs.map((tab, idx) => {
        const visivel = idx >= inicio && idx < fim;
        let cls = '';
        if (visivel && idx === inicio) cls = 'active';
        if (!visivel) cls = 'tab-oculta';
        return React.cloneElement(tab, { className: cls });
      });
    }

    
    const corpoRequerimento = (
      <div className="tabs-container-paginado">
        <DtpTabGroup className="dtp-default">
          {tabsExibidas}
        </DtpTabGroup>
        {temPaginacao && (
          <div className="tabs-navegacao">
            {this.state.tabPaginaAtual > 0 && (
              <a
                href="#"
                className="tab-nav-link"
                onClick={(e) => { e.preventDefault(); this.setState({ tabPaginaAtual: this.state.tabPaginaAtual - 1 }); }}
              ><span className="ico-triangle-left" title="Anterior"></span></a>
            )}
            {fim < todasTabs.length && (
              <a
                href="#"
                className="tab-nav-link"
                onClick={(e) => { e.preventDefault(); this.setState({ tabPaginaAtual: this.state.tabPaginaAtual + 1 }); }}
              ><span className="ico-triangle-right" title="Próximo"></span></a>
            )}
          </div>
        )}
      </div>
    );
    return corpoRequerimento;
  }

  tabRequerimento = () => (
    <DtpTab
      id="item1"
      className="active"
      title="Dados básicos"
      onClick={e => this.handleClick(e, 'item1')}
    >
      {this.formularioRequerimento()}
    </DtpTab>
  );

  tabHistorico = () => (
    <DtpTab
      id="item2"
      title="Estados"
      onClick={e => this.handleClick(e, 'item2')}
    >
      <DadosHistoricoRequerimento
        historicoEstados={this.state.requerimento.estados}
        auth={this.props.auth}
        labelMotivoCessacao={this.state.labelMotivoCessacaoManual }
      />
    </DtpTab>
  )

  tabPrescricao = () => ( 
    <DtpTab
      id="item5"
      title="Prescrição"
      onClick={e => this.handleClick(e, 'item5')}
    > 
      <DadosHistoricoPrescricao estadoFormulario={this.state} />
    </DtpTab>
  )

  indiceRelacao = (regime) => {
    return this.state.requerimento.relacoesPrevidenciariasDestinatario.findIndex(e => {
      return _.includes(e.regimePrevidenciario
        .map(r => r.idRegimePrevidenciarioSimulacao), regime.idRegimePrevidenciarioSimulacao);
    });
  }

  indiceRegime = (regime) => {
    return this.state.requerimento.relacoesPrevidenciariasDestinatario[this.indiceRelacao(regime)]
      .regimePrevidenciario
      .findIndex(e => e.idRegimePrevidenciarioSimulacao === regime.idRegimePrevidenciarioSimulacao);
  }

  atualizarTipoConcomitanteDescartado = (regime, valor) => {
    this.setState((currentState) =>
      update(currentState, {
        requerimento: {
          relacoesPrevidenciariasDestinatario: {
            [this.indiceRelacao(regime)]: {
              regimePrevidenciario: {
                [this.indiceRegime(regime)]: {
                  tipoConcomitanteDescartado: { $set: valor },
                },
              },
            },
          },
        },
      }));
  }

  confirmaVinculosConcomitantes = () => {
    const resultado = this.validacaoDeVinculosConcomitantes();
    if (!resultado.datasValidas) {
      trataMensagensErro([resultado.mensagemErro || 'Datas no formato inválido']);
      return;
    }

    this.setState({
      vinculosConcomitantesConfirmado: true,
      possuiVinculosConcomitantes: resultado.existeConcomitancia
    });
  };

  // competencias = regime => regime.remuneracoes.map(c => ({ ano: c.ano, mes: c.mes }));
  competencias = (regime) => {
    const colecao = regime.remuneracoes;
    if (colecao) {
      return regime.remuneracoes.map(c => ({ ano: c.ano, mes: c.mes }));
    }
  }
  marcarRegime = (regime) => {
    const competenciasParaAdicionar = this.competencias(regime);
    const regimesUtilizadosConcomitantes =
      this.state.requerimento.relacoesPrevidenciariasDestinatario
        .map(e => e.regimePrevidenciario)
        .flat()
        .filter(e => e.tipoConcomitanteDescartado === 0 || e.tipoConcomitanteDescartado == null)
        .filter(e => !_.isEmpty(_.intersectionWith(
          competenciasParaAdicionar,
          this.competencias(e),
          _.isEqual,
        )));
    // Descarta todos que colidem
    regimesUtilizadosConcomitantes.forEach(r => this.atualizarTipoConcomitanteDescartado(r, 1));

    // Adiciona o marcado
    this.atualizarTipoConcomitanteDescartado(regime, 0);
  }

  desmarcarRegime = (regime) => {
    // const competenciasParaAdicionar = this.competencias(regime);
    // const regimesConcomitantes = this.state.requerimento.relacoesPrevidenciariasDestinatario
    // .map(e => e.regimePrevidenciario)
    // .flat()
    // .filter(e => e.idRegimePrevidenciarioSimulacao !== regime.idRegimePrevidenciarioSimulacao)
    // .filter(e => !_.isEmpty(_.intersectionWith(competenciasParaAdicionar,
    // this.competencias(e),_.isEqual)));
    // if (!_.isEmpty(regimesConcomitantes)) {
    this.atualizarTipoConcomitanteDescartado(regime, 1);
    this.setState({ 
      vinculosConcomitantesConfirmado: false,
    });
    // }
  }

  marcarRegimeClick = (regime) => {
    const competenciasParaAdicionar = this.competencias(regime);
    const regimesUtilizadosConcomitantes =
      this.state.requerimento.relacoesPrevidenciariasDestinatario
        .map(e => e.regimePrevidenciario).flat()
        .filter(e => e.tipoConcomitanteDescartado === 0 || e.tipoConcomitanteDescartado == null)
        .filter(e => !_.isEmpty(_.intersectionWith(
          competenciasParaAdicionar,
          this.competencias(e), _.isEqual,
        )));

    let descartar = true;
    regimesUtilizadosConcomitantes.forEach((regimeConcomitante) => {
      if ((regimeConcomitante.dataInicio === regime.dataFim) ||
        (regimeConcomitante.dataFim === regime.dataInicio)) {
        descartar = false;
      }
      // else if ((regimeConcomitante.dataInicio !== regime.dataFim) ||
      // (regimeConcomitante.dataFim !== regime.dataInicio)) {
      //   descartar = false;
      // }
    });

    if (descartar) {
      // Descarta todos que colidem
      regimesUtilizadosConcomitantes.forEach(r => this.atualizarTipoConcomitanteDescartado(r, 1));
    }
    // Adiciona o marcado
    this.atualizarTipoConcomitanteDescartado(regime, 0);
    this.setState({ 
      vinculosConcomitantesConfirmado: false,
    });
  }

  tabRelacoesPrevidenciarias = () => (
    <DtpTab
      ref={this.tabVinculosRef}
      id="item3"
      title="Relações Previdenciárias Regime Origem"
      onClick={e => this.handleClick(e, 'item3')}
    >
      <DadosRelacoesPrevidenciarias
        relacoesPrevidenciarias={this.state.requerimento.relacoesPrevidenciariasDestinatario}
        marcarRegime={this.marcarRegimeClick}
        desmarcarRegime={this.desmarcarRegime}
        confirmar={this.confirmaVinculosConcomitantes}
        confirmado={this.state.vinculosConcomitantesConfirmado}
        validacaoConcomitancia={this.validacaoDeVinculosConcomitantes}
        acao={this.state.acao}
        estadoDoFormulario={this.state}
        rgpsEnvolvido={!(this.isDestinatarioRPPS() && this.isSolicitanteRPPS())}
      // rgpsEnvolvido={!(this.state.requerimento.destinatario === '01000' && this.state.requerimento.solicitante.codigo === '01000')}
      />
    </DtpTab>
  )

  isSolicitanteRPPS = () => User.logged().isRPPS();

  isDestinatarioRPPS() {
    if (['novo', 'realizar-analise'].includes(this.state.acao)) {
      return this.state.requerimento.destinatario
        && this.state.requerimento.destinatario.codigo !== '01000'
        && this.state.requerimento.destinatario.codigo !== null;
    }
    return this.state.requerimento.destinatario && this.state.requerimento.destinatario.codigo !== '01000';
  }

  tabResultadoSimulacao = () => (
    <DtpTab
      id="item4"
      title="Resultado da simulação"
      onClick={e => this.handleClick(e, 'item4')}
    >
      <DadosResultadoSimulacao
        resultadoSimulacao={this.state.requerimento.resultadoSimulacao}
      />
    </DtpTab>
  )

  tabConflitosPeriodos = () => (
    <DtpTab
      id="item6"
      title="Conflitos de períodos"
      onClick={e => this.handleClick(e, 'item6')}
    >
      <ListaConflitosPeriodos
        lista={this.state.requerimento.listaConflitosPeriodos}
        atualizarConflitosPeriodos={this.atualizarConflitosPeriodos}
        acao={this.state.acao}
        protocolo={this.state.requerimento.protocolo}
      />
    </DtpTab>
  )

  montaTabs = () => {
    const listaTabs = [];
    
    listaTabs.push(this.tabRequerimento());
    if (this.state.requerimento.estados &&
    this.state.requerimento.estados.length > 0) {
      listaTabs.push(this.tabHistorico());
    }
    if (this.state.requerimento.prescricao !== null && this.state.requerimento.prescricao &&
      (this.state.requerimento.estado === 11 || this.state.requerimento.estado === 12)) {
      listaTabs.push(this.tabPrescricao());
    }
    if (this.state.requerimento.relacoesPrevidenciariasDestinatario &&
      this.state.requerimento.relacoesPrevidenciariasDestinatario.length > 0) {
        listaTabs.push(this.tabRelacoesPrevidenciarias());
    }
    if (this.state.requerimento.resultadoSimulacao &&
      this.state.requerimento.resultadoSimulacao.length > 0) {
      listaTabs.push(this.tabResultadoSimulacao());
    } 
    if (this.state.requerimento.listaConflitosPeriodos &&
      this.state.requerimento.listaConflitosPeriodos.length > 0 &&
      !this.props.auth.checkPermission(['fornecer-parecer-medico-rpps'])){
      listaTabs.push(this.tabConflitosPeriodos());
    }
  
    return listaTabs;
  }

  obterMensagens(dataAbertura) {
    let mensagem = [];
    mensagem.push({ descricao: `A Data de Criação do Requerimento em ${dataAbertura} não será alterada.` });
    if (this.props.auth.checkPermission(['requerer-compensacao-rgps', 'analisar-compensacao-rgps'])) {
      mensagem = mensagem.concat(alertaPesquisarDadosPessoais, alertaPesquisarDadosBeneficio);
    }
    if (this.props.auth.checkPermission(['analisar-compensacao-rpps', 'requerer-compensacao-rpps'])) {
      mensagem = mensagem.concat(alertaPesquisarDadosPessoais);
    }
    return mensagem;
  }

  atualizarDataCessacao = (dataCessacao) => {
    const requerimento = { ...this.state.requerimento };
    requerimento.dataCessacaoBeneficio = dataCessacao;
    this.setState({ requerimento });
  }

  atualizarMotivoCessacao = (motivoCessacao) => {
    const requerimento = { ...this.state.requerimento };
    requerimento.motivoCessacaoManual = motivoCessacao;
    this.setState({ requerimento });
  }

  atualizarHistoricoAuditorias = (estadoAtualizado) => {
    this.setState((prevState) => {
    // console.log(prevState.requerimento.estados);
    return {
      requerimento: {
        ...prevState.requerimento,
        estados: prevState.requerimento.estados.map((estado) =>
          estado.codigoEstado === estadoAtualizado.codigoEstado
            ? estadoAtualizado
            : estado
        ),
      },
    };
  });
  }

  atualizarTipoSegregacaoMassaDestinatario = (tipo) => {
    const requerimento = { ...this.state.requerimento };
    requerimento.tipoSegregacaoDestinatario = tipo;
    this.setState({ requerimento });
  }

  atualizarTipoSegregacaoMassaSolicitante = (tipo) => {
    const requerimento = { ...this.state.requerimento };
    requerimento.tipoSegregacaoSolicitante = tipo;
    this.setState({ requerimento });
  }

  atualizarMotivoRejeicao = (paramMotivo, paramJustificativa) => {
    const requerimento = { ...this.state.requerimento };
    requerimento.motivo = paramMotivo;
    requerimento.justificativaRejeicao = paramJustificativa
    this.setState({
      requerimento: {
        ...requerimento,
      }
    }, () => this.confirmSendData());
    ;
  }

  handleModalRejeicaoRequerimento = () => {
    if (this.state.acao === 'salvarERejeitar') {
      // para exibir o botao salvar quando fechar o modal
      this.setState({ acao: 'novo', showRejeicaoRequerimentoModal: !this.state.showRejeicaoRequerimentoModal });
    } else {
      this.setState({ rejeitar: false, showRejeicaoRequerimentoModal: !this.state.showRejeicaoRequerimentoModal });
    }
  }

  onClickRejeitarRequerimento = () => {
    /**
    * Trata o click no botão de rejeitar requerimento
    */
    // this.setState({ acao:'rejeitar', showRejeicaoRequerimentoModal: !this.state.showRejeicaoRequerimentoModal });  
    this.setState({ rejeitar: true, showRejeicaoRequerimentoModal: !this.state.showRejeicaoRequerimentoModal });
  }

  onClickSalvarERejeitarRequerimento = () => {
    const requerimento = { ...this.state.requerimento };
    if (this.isSolicitanteRGPS()) {
      requerimento.solicitante = '01000';
    }
    this.setState({
      acao: 'salvarERejeitar',
      requerimento: {
        ...requerimento,
      },
      showRejeicaoRequerimentoModal: !this.state.showRejeicaoRequerimentoModal
    });
  }

  handleRejeicaoRequerimentoSent = () => {
    const mensagemSucesso = ['Requerimento Rejeitado.'];
    trataMensagemSucesso(mensagemSucesso);
    this.setState({
    }, () => this.handleModalRejeicaoRequerimento());
    this.props.history.goBack();
  }

  exibirBotaoRejeicao = () => {
    const { solicitante } = { ...this.state.requerimento };
    const { requerimento } = { ...this.state };
    const cnpjUsuarioLogado = User.logged().cnpjDoPapel();
    const cnpjSolicitante = solicitante ? solicitante.cnpj : null;
    const codigoSolicitante = solicitante ? solicitante.codigo : null;
    const ehUsuarioRGPS = User.logged().isUsuarioRGPS();
    let retorno = null;

    if ([1, 3, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17].includes(requerimento.estado)) {
      retorno = false;
    } else {
      retorno = (requerimento !== undefined && solicitante !== undefined) &&
        (['consulta', 'cumprir-exigencia'].includes(this.state.acao) && [2, 4, 5, 18].includes(requerimento.estado) && (cnpjSolicitante === cnpjUsuarioLogado) ||
          ((codigoSolicitante === '01000' && (ehUsuarioRGPS)))) || (this.state.rejeitar)
    }
    return retorno;
  };

  alteraListaArquivos = (arquivos) => {
    this.handleChange({ value: arquivos, isValid: arquivos.length > 0 }, 'arquivos');
  }

  addArquivo = (arquivo) => {
    let retorno = {};
    if (arquivo) {
      const { requerimento } = { ...this.state };
      const { tipoDocumento } = { ...this.state };
      retorno = {
        documento: arquivo,
        protocolo: requerimento.protocolo,
        tipoDocumento: tipoDocumento,
      };
    }
    return retorno;
  }

  handleChangeTipoDocumento = (e, name) => {
    this.setState({
      [name]: e.value,
    });
  }

  /**
  * Exclui um arquivo da lista
  */
  // deleteArquivo = (row) => {
  //   const { arquivos } = { ...this.state };
  //   arquivos.splice(row, 1);
  //   this.alteraListaArquivos(arquivos);
  // }

  deleteArquivo = (arquivoRemover) => {
    const { arquivos } = { ...this.state };
    const novaLista = arquivos.filter( arquivo => arquivo !== arquivoRemover
    );
    this.alteraListaArquivos(novaLista);
  }

  handleChangeFile = (arquivo) => {
    if (!arquivo) {
      this.alteraListaArquivos([], null);
      return;
    }

    const tamanhoDocumentoUpload = arquivo.size;

    // inclusão
    if ((tamanhoDocumentoUpload > constantes.tamanhoMaximoArquivoUpload)) {
      trataMensagensErro([
        `Certifique-se de que o documento ${arquivo.name} possui tamanho inferior a 3 mb.`,
      ]);
    } else {
      const novoArquivo = this.addArquivo(arquivo);

      this.alteraListaArquivos([novoArquivo], null);
    }
  }

  render() {
    if (this.state.reset) {
      return null;
    }

    if (this.state.showNoContent) {
      return (
        <DtpNoContent
          primaryText={this.state.noContentPrimaryMessage}
          secondaryText={this.state.noContentSecondaryMessage}
          show={this.state.showNoContent}
        />);
    }
    let listaAlertas;
    let listaExigencias;
    let botaoAcaoPrincipal;
    let botaoAcaoVoltar;
    let botaoAcaoConfirmarIndeferimento;
    let botaoRejeitar;
    let botaoSalvarERejeitar;
    let botaoComplementarAposentadoria;

    const configBotaoPrincipal = {
      onClick: this.handleSaveButton,
    };

    const configBotaoConfirmarIndeferimento = {
      onClick: this.handleSaveButtonConfirmarIndeferimento,
    };

    const configBotaoSalvarERejeitar = {
      onClick: this.onClickSalvarERejeitarRequerimento,
    };

    const configBotaoComplementarAposentadoria = {
      onClick: this.handleSaveButton,
    };

    if (this.state.acao === 'cumprir-exigencia') {
      listaExigencias = (<ListaExigencias exigencias={this.state.requerimento.exigencias} />);
      configBotaoPrincipal.permissoes = ['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'requerer-compensacao-rgps',
        'requerer-compensacao-rpps', 'gerenciar-negocio-dcomp'];
      configBotaoPrincipal.titulo = 'Salvar';
      configBotaoPrincipal.hint = 'Salvar alterações no requerimento e encerrar exigências atendidas';
    }

    if (this.state.acao === 'realizar-analise') {
      configBotaoPrincipal.permissoes = ['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'analisar-compensacao-rgps',
        'analisar-compensacao-rpps', 'gerenciar-negocio-dcomp'];
      configBotaoPrincipal.titulo = 'Finalizar Análise';
      configBotaoPrincipal.hint = 'Finalizar a análise do requerimento';

      listaAlertas = (<ListaAlertas alertas={this.state.requerimento.alertas} open={true} />);
      configBotaoPrincipal.permissoes = ['analisar-compensacao-rgps',
        'analisar-compensacao-rpps', 'requerer-compensacao-rgps', 'requerer-compensacao-rpps',
        'gerenciar-negocio-dcomp'];
    }
    if (this.state.acao === 'emitir-parecer-medico') {
      configBotaoPrincipal.permissoes = ['fornecer-parecer-medico-rpps'];
      configBotaoPrincipal.titulo = 'Emitir parecer';
      configBotaoPrincipal.hint = 'Emitir parecer do médico perito';
    }
    if (this.state.acao === 'qualificar') {
      configBotaoPrincipal.permissoes = ['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'requerer-compensacao-rgps',
        'requerer-compensacao-rpps', 'gerenciar-negocio-dcomp'];
      configBotaoPrincipal.titulo = 'Qualificar';
      configBotaoPrincipal.hint = 'Qualificar requerimento';
    }

    if (this.state.acao === 'indeferidos') {
      listaAlertas = (<ListaAlertas alertas={this.obterMensagens(this.state.requerimento.dataAberturaRequerimento)} open={true} />);
      configBotaoPrincipal.permissoes = ['requerer-compensacao-rgps', 'analisar-compensacao-rgps',
        'analisar-compensacao-rpps', 'requerer-compensacao-rpps'];
      configBotaoPrincipal.titulo = 'Reabrir requerimento';
      configBotaoPrincipal.hint = 'Reabrir requerimento';

      configBotaoConfirmarIndeferimento.permissoes = ['requerer-compensacao-rgps', 'analisar-compensacao-rgps',
        'analisar-compensacao-rpps', 'requerer-compensacao-rpps'];
      configBotaoConfirmarIndeferimento.titulo = 'Confirmar Indeferimento';
      configBotaoConfirmarIndeferimento.hint = 'Confirmar Indeferimento do requerimento';
    }

    if (this.state.acao === 'novo') {
      if (this.state.estadoFormulario === 'criado') {
        configBotaoPrincipal.permissoes = ['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'requerer-compensacao-rgps',
          'requerer-compensacao-rpps', 'gerenciar-negocio-dcomp'];
        configBotaoPrincipal.titulo = 'Novo';
        configBotaoPrincipal.hint = 'Criar novo requerimento';
        configBotaoPrincipal.onClick = this.handleNewButton;
      } else {
        configBotaoPrincipal.permissoes = ['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'requerer-compensacao-rgps',
          'requerer-compensacao-rpps', 'gerenciar-negocio-dcomp'];
        configBotaoPrincipal.titulo = 'Salvar';
        configBotaoPrincipal.hint = 'Salvar requerimento';

        configBotaoSalvarERejeitar.permissoes = ['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'requerer-compensacao-rgps'];
        configBotaoSalvarERejeitar.titulo = 'Salvar e rejeitar';
        configBotaoSalvarERejeitar.hint = 'Salvar o requerimento e rejeitar';
      }
    } else {
      if ((this.state.acao === 'consulta' || this.state.acao === 'rejeitar') && this.state.exibirUploadArquivosNaConsulta && !this.props.temBloqueioAtivoContratoDtp) {
        configBotaoPrincipal.permissoes = ['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'requerer-compensacao-rgps',
          'requerer-compensacao-rpps', 'gerenciar-negocio-dcomp'];
        configBotaoPrincipal.titulo = 'Carregar documento';
        configBotaoPrincipal.hint = 'Carregar documento';
      }
      if (this.state.acao === 'salvarERejeitar') {
        configBotaoPrincipal.permissoes = ['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'requerer-compensacao-rgps',
          'requerer-compensacao-rpps', 'gerenciar-negocio-dcomp'];
        configBotaoPrincipal.titulo = 'Salvar';
        configBotaoPrincipal.hint = 'Salvar requerimento';

        configBotaoSalvarERejeitar.permissoes = ['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'requerer-compensacao-rgps'];
        configBotaoSalvarERejeitar.titulo = 'Salvar e rejeitar';
        configBotaoSalvarERejeitar.hint = 'Salvar o requerimento e rejeitar';
      }
    }

    if (this.state.acao === 'complementar-aposentadoria') {
      configBotaoComplementarAposentadoria.permissoes = ['analisar-compensacao-rgps', 'analisar-compensacao-rpps', 'requerer-compensacao-rgps',
        'requerer-compensacao-rpps'];
      configBotaoComplementarAposentadoria.titulo = 'Complementar';
      configBotaoComplementarAposentadoria.hint = 'Complementar requerimento';
    }

    botaoAcaoVoltar = (
      <Button
        className="left"
        onClick={this.props.history.goBack}
        title="Voltar"
        hint="Voltar para tela anterior"
      />
    );

    if (configBotaoPrincipal.titulo) {
      if ((this.state.acao === 'salvarERejeitar') ||
        (this.state.acao !== 'qualificar' && this.state.acao !== 'consulta') ||
        ((this.state.acao === 'qualificar') && this.props.qualificacaoHabilitada) ||
        (this.state.acao === 'consulta' && this.state.exibirUploadArquivosNaConsulta)) {
        botaoAcaoPrincipal = (
          <ProtectedItem allowedPermissions={configBotaoPrincipal.permissoes}>
            <Button
              className="dtp-primary right"
              disabled={!this.formularioProntoParaEnvio()}
              title={configBotaoPrincipal.titulo}
              onClick={configBotaoPrincipal.onClick}
              hint={configBotaoPrincipal.hint}
            />
          </ProtectedItem>
        );
      }
    }

    if (configBotaoSalvarERejeitar.titulo) {
      if (this.state.acao === 'novo' || this.state.acao === 'salvarERejeitar') {
        botaoSalvarERejeitar = (
          <ProtectedItem allowedPermissions={configBotaoSalvarERejeitar.permissoes}>
            <Button
              className="dtp-primary right"
              disabled={!this.formularioProntoParaEnvio()}
              title={configBotaoSalvarERejeitar.titulo}
              onClick={configBotaoSalvarERejeitar.onClick}
              hint={configBotaoSalvarERejeitar.hint}
            />
          </ProtectedItem>
        );
      }
    }

    if (this.exibirBotaoRejeicao()) {
      botaoRejeitar = (
        <Button
          className="dtp-primary right"
          title="Rejeitar requerimento"
          onClick={this.onClickRejeitarRequerimento}
          hint="Rejeitar"
        />
      );
    }

    if (configBotaoConfirmarIndeferimento.titulo && this.state.acao === 'indeferidos') {
      botaoAcaoConfirmarIndeferimento = (
        <ProtectedItem allowedPermissions={configBotaoPrincipal.permissoes}>
          <Button
            className="dtp-btn right"
            title={configBotaoConfirmarIndeferimento.titulo}
            onClick={configBotaoConfirmarIndeferimento.onClick}
            hint={configBotaoConfirmarIndeferimento.hint}
          />
        </ProtectedItem>
      );
    }

    if (configBotaoComplementarAposentadoria.titulo && this.state.acao === 'complementar-aposentadoria') {
      botaoComplementarAposentadoria = (
        <ProtectedItem allowedPermissions={configBotaoComplementarAposentadoria.permissoes}>
          <Button
            className="dtp-primary right"
            disabled={!this.formularioProntoParaEnvio()}
            title={configBotaoComplementarAposentadoria.titulo}
            onClick={configBotaoComplementarAposentadoria.onClick}
            hint={configBotaoComplementarAposentadoria.hint}
          />
        </ProtectedItem>
      );
    }

    let modalAlerta;
    if (this.state.showModalAlerta) {
      modalAlerta = (<ModalAlerta
        alertas={this.state.alertas}
        aceitar={this.confirmSendData}
        handleModal={this.handleFechamentoModalAlerta}
        showModal
      />);
    }

    let modalAlertaRequerimentosPeriodos;
    if (this.state.showModalAlertaRequerimentosPeriodos) {
      modalAlertaRequerimentosPeriodos = (<ModalAlerta
        alertas={this.state.alertas}
        aceitar={this.substituirRequerimentosPeriodos}
        handleModal={this.handleFechamentoModalAlertaRequerimentosPeriodos}
        labelTitulo="substituir períodos do requerimento"
        labelBotaoConfirmarAcao="sim"
        labelBotaoCancelarAcao="não"
        showModal
      />);
    }

    let modalAlertaRequerPerConcomitancia;
    if (this.state.showModalAlertaRequerPerConcomitancia) {
      modalAlertaRequerPerConcomitancia = (<ModalAlerta
        alertas={this.state.alertas}
        aceitar={this.handleSaveButton}
        handleModal={this.handleFechamentoModalAlertaRequerPerConcomitancia}
        labelTitulo = "Salvar requerimento com conflitos de períodos ?"
        labelBotaoConfirmarAcao="sim"
        labelBotaoCancelarAcao="não"
        showModal
      />);
    }

    let modalRejeicaoRequerimento;
    if (this.state.showRejeicaoRequerimentoModal) {
      modalRejeicaoRequerimento = (<ModalRejeicaoRequerimento
        acao={this.state.acao}
        protocolo={this.state.requerimento.protocolo}
        requerimento={this.state.requerimento}
        handleModal={() => this.handleModalRejeicaoRequerimento()}
        showModal
        tipoRequerimento={this.state.tipoRequerimento}
        handleRejeicaoRequerimentoSent={this.handleRejeicaoRequerimentoSent}
        handleSalvarERejeitar={this.atualizarMotivoRejeicao}
        rejeitar={this.state.rejeitar}
      />);
    }

    let modalAlertaCtcNaoEncontrada;
    if (this.state.showModalAlertaCtcNaoEncontrada) {
      modalAlertaCtcNaoEncontrada = (<ModalAlerta
        alertas={[{ descricao: msgCtcNaoEncontrada.descricao }]}
        aceitar={this.handleFechamentoModalCtcNaoEncontrada}
        handleModal={this.handleFechamentoModalCtcNaoEncontrada}
        labelTitulo="CTC não encontrada."
        labelBotaoConfirmarAcao="ok"
        esconderBotaoCancelar
        showModal
      />);
    }

    let modalAlertaReqAprovadoSemDataIngresso;
    if (this.state.showModalAlertaReqAprovadoSemDataIngresso) {
      modalAlertaReqAprovadoSemDataIngresso = (<ModalAlerta
        alertas={[{ descricao: `${msgReqAprovadoSemDataIngresso.descricao1.texto1}${msgReqAprovadoSemDataIngresso.descricao2.texto2}` }]}
        aceitar={this.handleFechamentoModalAlertaReqAprovadoSemData}
        handleModal={this.handleFechamentoModalAlertaReqAprovadoSemData}
        labelTitulo="Requerimento existente."
        labelBotaoConfirmarAcao="ok"
        esconderBotaoCancelar
        showModal
      />);
    }

    let modalRecalcularTempoRO;
    if (this.state.showModalRecalcularTempoRO) {
      modalRecalcularTempoRO = (<ModalTempoRO
        alertas={[{
          descricao: this.state.requerimento.requerimentoPeriodos.length > 0 ? msgRecalcularTempoRO.descricaoComPeriodos.descricao :
            msgRecalcularTempoRO.descricaoSemPeriodos.descricao
        }]}
        aceitar={this.recalcularTempoRO}
        handleModal={this.handleModalRecalcularTempoRO}
        labelTitulo="Substituir tempo Contribuição no Regime de Origem (dias)."
        //labelBotaoConfirmarAcao="Aceitar"
        //labelBotaoCancelarAcao="Cancelar"
        showModal
      />);
    }

    const retorno = (
      <DtpContentContainer>
        {listaAlertas}
        {listaExigencias}
        {this.montaCorpoRequerimento()}
        <div className="row">
          {this.state.exibirBotaoVoltar ? botaoAcaoVoltar : ''}
          {botaoAcaoPrincipal}
          {botaoSalvarERejeitar}
          {botaoRejeitar}
          {botaoAcaoConfirmarIndeferimento}
          {botaoComplementarAposentadoria}
        </div>
        {modalAlerta}
        {modalRejeicaoRequerimento}
        {modalAlertaRequerimentosPeriodos}
        {modalAlertaRequerPerConcomitancia}
        {modalAlertaCtcNaoEncontrada}
        {modalAlertaReqAprovadoSemDataIngresso}
        {modalRecalcularTempoRO}
      </DtpContentContainer>
    );
    return retorno;
  }
}

RequerimentoAposentadoria.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      protocolo: PropTypes.string,
      acao: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    goBack: PropTypes.function,
  }).isRequired,
  tiposDocumentos: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  arquivos: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }),
  destinatarios: PropTypes.arrayOf({
    label: PropTypes.string,
    value: PropTypes.number,
    tipoRegimeProprio: PropTypes.number,
  }).isRequired,
  qualificacaoHabilitada: PropTypes.bool.isRequired,
  temBloqueioAtivoContratoDtp: PropTypes.bool.isRequired,
  // motivosCessacaoRequerimentoAposentadoria: PropTypes.arrayOf(PropTypes.shape({
  //   value: PropTypes.string,
  //   label: PropTypes.string,
  // })),
  motivosCessacao: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.number,
    label: PropTypes.string,
  })),
};

RequerimentoAposentadoria.defaultProps = {
  match: null,
  tiposDocumentos: [],
  auth: null,
  arquivos: null,
  // motivosCessacaoRequerimentoAposentadoria: null,
  motivosCessacao: null,
};

const mapStateToProps = state => ({
  tiposDocumentos: state.base.tiposDocumentos,
  destinatarios: state.base.destinatarios,
  qualificacaoHabilitada: state.base.configuracoesFrontend.habilitarQualificacao,
  temBloqueioAtivoContratoDtp: state.base.configuracoesFrontend.temBloqueioAtivoContratoDtp,
  requerimentoPeriodos: state.base.requerimentoPeriodos,
  // motivosCessacaoRequerimentoAposentadoria: state.base.motivosCessacaoRequerimentoAposentadoria,
  motivosCessacao: state.base.motivosCessacao,
});
export default connect(mapStateToProps)(RequerimentoAposentadoria);



// WEBPACK FOOTER //
// ./src/pages/requerimentos/Aposentadoria/RequerimentoAposentadoria.jsx